<template>
  <div
    :style="style"
    v-show="showDrag"
    ref="drag"
    :class="[
      {
        [classNameActive]: enabled,
        [classNameDragging]: dragging,
        [classNameResizing]: resizing,
        [classNameDraggable]: draggable,
        [classNameResizable]: resizable,
        ['nofill']: nofill,
      },
      className,
    ]"
    @mousedown="elementMouseDown"
    @touchstart="elementTouchDown"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @keyup.delete="remove(dragIndex)"
  >
   

    <!-- <i
      v-if="enabled"
      @mousedown.stop.prevent="handleRotateTouchDown(handle, $event)"
      @touchstart.stop.prevent="handleRotateDown(handle, $event)"
      @touchend.stop.prevent="handleRotateUp"
      class="iconfont icon-xuanzhuan"
    ></i> -->
    <!-- <div v-if="enabled && type == 2" class="moveBOX">
      <i @click="fangda" class="iconfont icon-fangda1"></i>
      <img
        @mousedown.stop.prevent="handleMoveTouchDown(handle, $event)"
        @touchstart.stop.prevent="handleMoveDown(handle, $event)"
        @touchend.stop.prevent="handleRotateUp"
        src="../assets/move.png"
        alt=""
      />
      <i @click="suoxiao" class="iconfont icon-suoxiao1"></i>
    </div>
    <div v-if="enabled && type == 1" class="moveBOX">
      <i @click="fangda" class="iconfont icon-fangda1"></i>
      <img
        @mousedown.stop.prevent="handleMoveTouchDown(handle, $event)"
        @touchstart.stop.prevent="handleMoveDown(handle, $event)"
        @touchend.stop.prevent="handleRotateUp"
        src="../assets/move.png"
        alt=""
      />
      <i @click="suoxiao" class="iconfont icon-suoxiao1"></i>
    </div> -->
    <a-spin style="width: 100%;height: 100%;" :spinning="spinning">
      <slot> </slot>
      <img
      v-if="backgroundImg"
      class="back"
      onselect="false"
      :style="{
        width: '100%',
        height:this.type == 1 || this.type == 9 ? '100%' : 'auto',
        visibility: 'hidden',
      }"
      ref="backRef"
      :src="backgroundImg"
      alt=""
    />


    <div
      v-if="backgroundImg && type == 1 "
      class="back"
      :style="{
        position: 'absolute',
        borderRadius: bRadius + 'px',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
      }"
    >
      <img
        class="rotateImg"
        :src="backgroundImg"
        :class="moveState2 ? 'moves' : ''"
        :style="imgStyle12"
        alt=""
      />
    </div>
    <!-- <div v-if="type==1" style="position: absolute;left: 0;top: -100%;z-index: 10000;">
      <div>宽{{ this.width }}</div>
      <div>高{{ this.height }}</div>
      <div>缩放{{ this.picScale }}</div>
      <div>照片宽{{ pw }}</div>
      <div>照片高{{ this.picLeft }}</div>
      <div>照片left{{ this.picLeft }}</div>
      <div>照片top{{ this.picTop }}</div>
      <div>初始化left{{ this.originPhotoLeft }}</div>
      <div>初始化top{{ this.originPhotoTop }}</div>
    </div> -->
    <div
      v-if="backgroundImg && type == 0 "
      class="back"
      :style="{
        position: 'absolute',
        borderRadius: bRadius + 'px',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
      }"
    >
      <img
        class="rotateImg"
        :src="backgroundImg"
        :class="moveState2 ? 'moves' : ''"
        :style="imgStyle2"
        alt=""
      />
    </div>

    <div
      v-if="backgroundImg && type == 9"
      class="back"
      :style="{
        position: 'absolute',
        borderRadius: bRadius + 'px',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
      }"
    >
      <img
        class="rotateImg"
        :src="backgroundImg"
        :class="moveState2 ? 'moves' : ''"
        :style="imgStyle3"
        alt=""
      />
    </div>
    <div
      v-if="backgroundImg && type == 9 && moveState"
      @mousedown.stop.prevent="handleMoveTouchDown(null, $event)"
      @touchstart.stop.prevent="handleMoveDown(null, $event)"
      class="back2"
      :style="{
        position: 'absolute',
        borderRadius: bRadius + 'px',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }"
    >
    <img
        class="rotateImg"
        :src="backgroundImg"
        :style="imgStyle3"
        alt=""
      />
    </div>
    
    <div
      v-if="backgroundImg && type == 2"
      class="back"
      :style="type2Style"
    ></div>
    <img
      class="rotateImg"
      :src="backgroundImg"
      v-if="backgroundImg && type == 2"
      style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;"
      alt=""
    />
    <!-- <div
      v-if="backgroundImg"
      @dblclick="showEdit"
      class="back"
      :style="{
        position: 'absolute',
        borderRadius: bRadius + 'px',
        overflow: 'hidden',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        visibility: this.type == 2 ? 'hidden' : 'visibile',
        backgroundImage: 'url(' + backgroundImg + ')',
        backgroundSize: `${picScale * 100}% auto`,
        backgroundPosition: `${picLeft}px ${picTop}px`,
        backgroundRepeat: 'no-repeat',
        opacity: moveState ? 0.8 : 1,
      }"
    >
    </div> -->
    <!-- <canvas
      v-if="type == 2"
      style="position:absolute;left:0;top:0"
      @mousedown="handleMove(handle, $event)"
      @touchstart="handleMove(handle, $event)"
      :width="width"
      :height="height"
      :id="frameId ? 'frame' + frameId : 'frame' + dragIndex"
    ></canvas> -->
    <img
      v-if="type == 2 && showCanvasImg && canvasImg"
      :src="canvasImg"
      style="position:absolute;left:0;top:0"
      @mousedown="handleMove(handle, $event)"
      @touchstart="handleMove(handle, $event)"
      :style="{ width: width + 'px', height: height + 'px' }"
    />
    <img
      v-if="type == 2 && showPhoto && moveState"
      :style="photoStyle"
      :src="showPhoto"
      @mousedown.stop.prevent="handleMoveTouchDown(null, $event)"
      @touchstart.stop.prevent="handleMoveDown(null, $event)"
      alt=""
    />
    <div
      v-if="((!editState && type == 5) || type == 0) && !backgroundImg"
      v-html="content ? content : isPhone ? '请编辑文字' : '双击编辑文本'"
      @dblclick="handleEditState"
      @touchstar="start"
      @touchend="end"
      ref="textarea"
      :style="style3"
      onselect="false"
      class="text"
    ></div>
    <textarea
      v-if="editState && (type == 1 || type == 5)"
      v-html="content"
      @blur="textChange"
      ref="textarea"
      :style="style3"
      style="height:100%"
      onselect="false"
      class="text"
    >
    </textarea>
    <textarea
      v-if="editState && type == 0 && content"
      v-html="content"
      @blur="textChange"
      ref="textarea"
      :style="style3"
      style="height:100%"
      onselect="false"
      class="text"
    >
    </textarea>
    <div
      v-if="type == 4 && levelType == 1"
      class="stars"
      :style="{
        color: fontColor,
        fontSize: fontSize < 12 ? '12px' : fontSize + 'px',
      }"
    >
      <i
        :style="{
          color: fontColor,
          fontSize: fontSize < 12 ? '12px' : fontSize + 'px',
        }"
        @click="changeLevel(n)"
        v-show="levelType == 1"
        v-for="n in 3"
        :key="'star' + n"
        class="icon iconfont2 "
        :class="n <= level ? 'icon-star-full' :'icon-star' "
        
      ></i>
    </div>
    <div
      v-if="type == 4 && levelType == 2"
      class="stars"
      :style="{
        color: fontColor,
        fontSize: fontSize < 12 ? '12px' : fontSize + 'px',
      }"
    >
      <div
        @click="changeLevel(n)"
        v-for="n in levelNum"
        :key="'gou' + n"
        class="star-item"
      >
        <i
          :style="{
            color: fontColor,
            fontSize: fontSize < 12 ? '12px' : fontSize + 'px',
          }"
          v-show="levelType == 2"
          class="icon iconfont2"
          :class="n == level ? '' : enabled ? 'hui' : 'hide'"
          >√</i
        >
      </div>
    </div>
    <!-- <img
      v-if="enabled && type == 2 && showPhoto"
      class="move"
      :style="moveStyle"
      src="../assets/move.png"
      @click="handleMove(handle, $event)"
      @touchstart="handleMove(handle, $event)"
      alt=""
    /> -->
    <div v-if="locking && enabled" @click="unlock" class="lock-drag">
      <img src="../assets/lock2.png" alt="" />
      <!-- <i class="miconfont icon-suoding"></i> -->
    </div>
    <div v-if="type == 3 && enabled" @click="handleConfirmComb" class="type3">
      确定
    </div>

    <div v-for="n in 4" :key="n" class="posline" :style="lineStyle(n)"></div>
    <!-- (type != 11 || handle == 'tl' || handle == 'tr' || handle=='bl' || handle == 'br') -->
    <div
      v-for="handle in actualHandles"
      v-if="(type != 8 || handle == 'mr' || handle == 'ml') && !cateMode && (type != 11 || handle == 'tl' || handle == 'tr' || handle=='bl' || handle == 'br')"
      :key="handle"
      :class="[classNameHandle, classNameHandle + '-' + handle]"
      :style="handleStyle(handle)"
      @mousedown.stop.prevent="handleDown(handle, $event)"
      @touchstart.stop.prevent="handleTouchDown(handle, $event)"
    >
      <slot :name="handle"></slot>
    </div>
    </a-spin>
   
  </div>
</template>

<script>
// type:0 文本框/素材 ：
// 1）没有文本，有背景图backgroundImg，算素材，为已填充
// 2）有文本，则判断是否为默认的情况【文本框、添加文本、请添加文本】，是的为未填充，其他内容为已填充
// type:1 矢量相框 判断backgroundImg
// type:2 普通相框 判断showPhoto
// type:3 组合，不用判断
// type:4 评级 （评级默认就有值，应该也不用判断）

// 新版本增加
// type:5 新本框，独立于以前的组件。只包含文本属性，需要后台配合改下
// type:6 svg图标
// svg_id String 默认 空
// svg_type 1 单色 2双色
// svg_code svg代码 是字符串 默认空
// type:7 矢量素材（方形、圆形）
// type:8 矢量素材（线）
// type:9 新矢量相框 判断backgroundImg
import _ from "lodash";
import {
  matchesSelectorToParentElements,
  getComputedSize,
  addEvent,
  removeEvent,
} from "../utils/dom";
import {
  computeWidth,
  computeHeight,
  restrictToBounds,
  snapToGrid,
  computeRotate,
} from "../utils/fns";

const events = {
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup",
  },
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend",
  },
};

// 禁止用户选取
const userSelectNone = {
  userSelect: "none",
  MozUserSelect: "none",
  WebkitUserSelect: "none",
  MsUserSelect: "none",
};
// 用户选中自动
const userSelectAuto = {
  userSelect: "auto",
  MozUserSelect: "auto",
  WebkitUserSelect: "auto",
  MsUserSelect: "auto",
};

let eventsFor = events.mouse;

export default {
  replace: true,
  name: "vue-draggable-resizable",
  props: {
    spinning:{
      type: Boolean,
      default: false,
    },
    cateMode:{
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    stepState: {
      type: Boolean,
      default: false,
    },
    listen: {
      type: Boolean,
      default: true,
    },
    showDrag: {
      type: Boolean,
      default: true,
    },
    isCom: {
      type: Boolean,
      default: false,
    },
    fontFamily: {
      type: String,
      default: "",
    },
    photoRotate: {
      type: [Number, String],
      default: 0,
    },
    levelNum: {
      type: [Number, String],
      default: 3,
      validator: (val) => {
        if (typeof val === "string") {
          return parseInt(val);
        }
        return val;
      },
    },
    levelType: {
      type: [Number, String],
      default: 1,
      validator: (val) => {
        if (typeof val === "string") {
          return parseInt(val);
        }
        return val;
      },
    },
    level: {
      type: Number,
      default: 1,
    },
    showCanvasImg: {
      type: Boolean,
      default: false,
    },
    frameId: {
      type: String,
      default: "",
    },
    photoLeft: {
      type: Number,
      default: 0,
    },
    photoTop: {
      type: Number,
      default: 0,
    },
    photoScale: {
      type: [Number, String],
      default: 1,
      validator: (val) => {
        if (typeof val === "string") {
          if (val == '0.00') {
            return 1
          } else {
            return parseFloat(val);
        }
          }
          
        return val;
      },
    },
    textAlign: {
      type: String,
      default: "left",
    },
    fontWeight: {
      type: String,
      default: "normal",
    },
    nofill: {
      type: Boolean,
      default: false,
    },
    fontStyle: {
      type: String,
      default: "normal",
    },
    writingMode: {
      type: String,
      default: "horizontal-tb",
    },
    textIndent: {
      type: Number,
      default: 0,
    },
    textDecoration: {
      type: String,
      default: "normal",
    },
    lineHeight: {
      type: [Number, String],
      default: 28,
    },
    showPhoto: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1,
    },
    bImg2: {
      type: String,
      default: "",
    },
    dIndex: {
      type: Number,
      default: 0,
    },
    o: {
      type: Number,
      default: 1,
    },
    l: {
      type: Boolean,
      default: false,
    },
    allIndex: {
      type: Number,
      default: 1,
    },
    className: {
      type: String,
      default: "vdr",
    },
    text: {
      type: String,
      default: null,
    },
    classNameDraggable: {
      type: String,
      default: "draggable",
    },
    classNameResizable: {
      type: String,
      default: "resizable",
    },
    backColor: {
      type: String,
      default: "#ccc",
    },
    borderColor: {
      type: String,
      default: "",
    },
    fontColor: {
      type: String,
      default: "rgba(0, 0, 0, 1)",
    },
    classNameDragging: {
      type: String,
      default: "dragging",
    },
    classNameResizing: {
      type: String,
      default: "resizing",
    },
    classNameActive: {
      type: String,
      default: "active",
    },
    classNameHandle: {
      type: String,
      default: "handle",
    },
    disableUserSelect: {
      type: Boolean,
      default: true,
    },
    enableNativeDrag: {
      type: Boolean,
      default: false,
    },
    preventDeactivation: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: [String, Number],
      default: 0,
    },
    borderLeft: {
      type: Number,
      default: 0,
    },
    borderRight: {
      type: Number,
      default: 0,
    },
    borderTop: {
      type: Number,
      default: 0,
    },
    borderBottom: {
      type: Number,
      default: 0,
    },
    borderStyle: {
      type: String,
      default: "solid",
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    textShadow: {
      type: Boolean,
      default: false,
    },
    bRadius: {
      type: Number,
      default: 0,
    },
    borderColor: {
      type: String,
      default: "",
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    paddingTop: {
      type: Number,
      default: 0,
    },
    paddingRight: {
      type: Number,
      default: 0,
    },
    paddingBottom: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    resizable: {
      type: Boolean,
      default: true,
    },
    backImg: {
      type: String,
      default: "",
    },
    // 锁定宽高比
    lockAspectRatio: {
      type: Boolean,
      default: false,
    },
    w: {
      type: [Number, String],
      default: 200,
      validator: (val) => {
        if (typeof val === "number") {
          return val > 0;
        }
        return val === "auto";
      },
    },
    h: {
      type: [Number, String],
      default: 200,
      validator: (val) => {
        if (val != "auto") {
          return parseInt(val) ? parseInt(val) : "auto";
        }
        return "auto";
      },
    },
    minWidth: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0,
    },
    minHeight: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0,
    },
    maxWidth: {
      type: Number,
      default: null,
      validator: (val) => val >= 0,
    },
    maxHeight: {
      type: Number,
      default: null,
      validator: (val) => val >= 0,
    },
    r: {
      type: Number,
      default: 0,
    },
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    z: {
      type: [String, Number],
      default: 0,
    },
    handles: {
      type: Array,
      default: () => ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"],
      validator: (val) => {
        const s = new Set(["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]);

        return new Set(val.filter((h) => s.has(h))).size === val.length;
      },
    },
    dragHandle: {
      type: String,
      default: null,
    },
    dragCancel: {
      type: String,
      default: null,
    },
    axis: {
      type: String,
      default: "both",
      validator: (val) => ["x", "y", "both"].includes(val),
    },
    grid: {
      type: Array,
      default: () => [1, 1],
    },
    parent: {
      type: [Boolean, String],
      default: false,
    },
    onDragStart: {
      type: Function,
      default: () => true,
    },
    onDrag: {
      type: Function,
      default: () => true,
    },
    onResizeStart: {
      type: Function,
      default: () => true,
    },
    onResize: {
      type: Function,
      default: () => true,
    },
    // 冲突检测
    isConflictCheck: {
      type: Boolean,
      default: false,
    },
    // 元素对齐
    snap: {
      type: Boolean,
      default: false,
    },
    // 当调用对齐时，用来设置组件与组件之间的对齐距离，以像素为单位
    snapTolerance: {
      type: Number,
      default: 5,
      validator: function(val) {
        return typeof val === "number";
      },
    },
    // 缩放比例
    scaleRatio: {
      type: Number,
      default: 1,
      validator: (val) => typeof val === "number",
    },
    // 缩放比例
    photoWidth: {
      type: Number,
      default: 1,
      validator: (val) => typeof val === "number",
    },
    // 缩放比例
    photoHeight: {
      type: Number,
      default: 1,
      validator: (val) => typeof val === "number",
    },
    // handle是否缩放
    handleInfo: {
      type: Object,
      default: () => {
        return {
          size: 12,
          offset: -6,
          switch: true,
        };
      },
    },
  },

  data: function() {
    return {
      editState: false,
      resizingState: false,
      moveState: false,
      moveState2: false,
      moving: false,
      changeState: false,
      originR: this.r,
      left: this.x,
      top: this.y,
      right: null,
      bottom: null,
      width: null,
      height: this.h ? this.h : "auto",
      rotate: this.r,
      borderRadius: this.bRadius,
      widthTouched: false,
      heightTouched: false,
      aspectFactor: null,
      content: this.exhcnageBr(this.text),
      parentWidth: null,
      parentHeight: null,
      selectColor: false,
      minW: this.minWidth,
      minH: this.minHeight,
      backgroundImg: this.backImg,
      maxW: this.maxWidth,
      maxH: this.maxHeight,
      locking: this.l,
      handle: null,
      enabled: this.active,
      resizing: false,
      dragging: false,
      rotating: false,
      zIndex: this.z,
      bColor: this.backColor,
      fColor: this.fontColor,
      fSize: this.fontSize,
      bordersColor: this.borderColor,
      bLeft: Number(this.borderLeft),
      bTop: Number(this.borderTop),
      bRight: Number(this.borderRight),
      bBottom: Number(this.borderBottom),
      bStyle: this.borderStyle,
      opacity: parseInt(this.o),
      pLeft: Number(this.paddingLeft),
      pTop: Number(this.paddingTop),
      pRight: Number(this.paddingRight),
      pBottom: Number(this.paddingBottom),
      dragIndex: this.dIndex,
      backimg2: this.bImg2,
      fWeight: this.fontWeight,
      fFamily: this.fontFamily,
      fStyle: this.fontStyle,
      tAlign: this.textAlign,
      lHeight: this.lineHeight,
      moveLeft: 0,
      moveTop: 0,
      picScale: Number(this.photoScale),
      picLeft: Number(this.photoLeft),
      picTop: Number(this.photoTop),
      picRotate: Number(this.photoRotate),
      picWidth: Number(this.photoWidth),
      picHeight: Number(this.photoHeight),
      canvasImg: "",
      moveboxLeft: 0,
      moveboxTop: 0,
      minScale: 1,
      originPhotoLeft: 0,
      originPhotoTop: 0,
      deltaWidth: 0,
      deltaHeight: 0,
      transpantPx: [0, 0, 0, 0],
      photoMsg: {
        width: 100,
        Height: 100,
      },
      isPhone:false
    };
  },

  created: function() {
    this.loadimg();
    this.isPhone = this.isMobile()
    // eslint-disable-next-line 无效的prop：minWidth不能大于maxWidth
    if (this.maxWidth && this.minWidth > this.maxWidth)
      console.warn(
        "[Vdr warn]: Invalid prop: minWidth cannot be greater than maxWidth"
      );
    // eslint-disable-next-line 无效prop：minHeight不能大于maxHeight'
    if (this.maxWidth && this.minHeight > this.maxHeight)
      console.warn(
        "[Vdr warn]: Invalid prop: minHeight cannot be greater than maxHeight"
      );

    this.resetBoundsAndMouseState();
  },
  mounted: function() {
    // this.matchText()
    if (this.listen) {
      this.$refs["drag"].addEventListener(
        "drop",
        (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.$emit("dropImg", this.dragIndex, e);
          var files = e.dataTransfer.files;
          var formData = new FormData();
          for (var i = 0; i < files.length; i++) {
            formData.append("file" + i, files[i]);
          }
        },
        false
      );
    }

    if (!this.enableNativeDrag) {
      this.$el.ondragstart = () => false;
    }

    const [parentWidth, parentHeight] = this.getParentSize();

    this.parentWidth = parentWidth;
    this.parentHeight = parentHeight;
    let [width, height] = getComputedSize(this.$el);
    if (this.$refs.backRef && (!this.h || this.h == "auto")) {
      height = (height * this.w) / width;
    } else {
      height = this.h;
    }
    this.aspectFactor =
      (this.w !== "auto" ? parseInt(this.w) : width) /
      (this.h !== "auto" && this.h ? parseInt(this.h) : height);
    this.width = this.w !== "auto" ? parseInt(this.w) : width;
    this.height = this.h !== "auto" && this.h ? parseInt(this.h) : height;
    this.right = this.parentWidth - this.width - this.left;
    this.bottom = this.parentHeight - this.height - this.top;
    // this.$emit('resizeHeight',this.height,this.dragIndex)
    this.settingAttribute();
    if (this.listen) {
      addEvent(document.documentElement, "mousedown", this.deselect);
      addEvent(document.documentElement, "touchstar", this.deselect);
      addEvent(document.documentElement, "touchend touchcancel", this.deselect);
      addEvent(window, "resize", this.checkParentSize);
    }
    this.$nextTick(() => {
      if (this.type == 5) {
        var Height = window.getComputedStyle(this.$refs.textarea).height
          ? window.getComputedStyle(this.$refs.textarea).height
          : "0";
          const h = this.height - Number(Height.replace("px", ""))
        this.height = Number(Height.replace("px", ""));
        this.bottom = this.bottom +  h
        console.log(this.bottom + 'bottom')
      }
    });
  },
  beforeDestroy: function() {
    // this.type == 1 || this.type == 9;
    removeEvent(document.documentElement, "mousedown", this.deselect);
    removeEvent(document.documentElement, "touchstart", this.handleUp);
    removeEvent(document.documentElement, "mousemove", this.move);
    removeEvent(document.documentElement, "touchmove", this.move);
    removeEvent(document.documentElement, "mouseup", this.handleUp);
    removeEvent(
      document.documentElement,
      "touchend touchcancel",
      this.deselect
    );

    removeEvent(window, "resize", this.checkParentSize);
  },

  methods: {
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
    changeFrame(item) {
      var drags = [];
      var oldDrag = [];
      this.backgroundImg = this.clearUrl(item.backgroundImg) ;
      this.backImg2 = this.clearUrl(item.backImg2) ;
      this.height = "auto";
      this.bLeft = 0 
      this.bRight = 0 
      this.bTop = 0
      this.bBottom = 0
      console.log('changeframe' ,this.picTop,this.photoTop)
      if (!this.picTop) this.picTop = 0
      setTimeout(() => {
        if (!this.showPhoto) {
          this.$emit("changeDrag", this.dragIndex);
          return 
        }
        this.resizeCanvas(true)
      }, 40);
    },
    setData(data) {
      this.left = data.left
      this.top = data.top
      
      if (data && data.rotate) {
        this.rotate = data.rotate
      }
      if (data && data.borderRadius) {
        this.borderRadius = data.borderRadius
      }
      if (data && data.width) {
        this.width = data.width
      }
      if (data && data.height) {
        this.height = data.height
      }

      if (this.type == 9) {
        this.initPhotoNew(false)
      } else if (this.type == 2) {
        console.log(this.orginWidth) 
        if (!this.orginWidth) {
          this.orginWidth = this.width
        } 
        if (!this.orginPicLeft) {
          this.orginPicLeft = this.picLeft
          this.orginPicTop = this.picTop
        }
        const p = 1 + (this.width - this.orginWidth) / this.orginWidth
        this.picLeft = this.orginPicLeft * p
        this.picTop = this.orginPicTop * p
        this.resizeCanvas()
      }
    },
    update() {
      if (this.type == 9) {
        this.initPhotoNew(true)
      }  else {
        this.$emit("changeDrag", this.dragIndex);
      }
    },
    changePicScale(state) {
      
      if (this.type == 9) {
        this.checkRange2();
        setTimeout(() => {
          this.$emit(
            "pmoving",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
        }, 20);
        return false;
      } else if (this.type == 2) {
        console.log('photochange',this.picTop,this.deltaScale,this.photoTop,this.photoScale)
        if (this.deltaScale && this.deltaScale != 0) {
          this.picLeft =
            this.picLeft -
            ((this.width - this.transpantPx[0] - this.transpantPx[2]) / 2) *
              this.deltaScale;
          this.picTop =
            this.picTop -
            ((this.height - this.transpantPx[1] - this.transpantPx[3]) / 2) *
              this.deltaScale;
          this.deltaScale = 0;
          console.log('photochange',this.picTop)
        }
        console.log('photochange',this.picTop)
        setTimeout(() => {
          this.checkRange('changePicScale');
          this.$emit(
            "photoChange",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
        }, 20);
        return false;
      }
      var val = this.picScale;
      if (this.resizing) return false;
      if (
        (this.type == 1 || this.type == 9) &&
        this.width &&
        !this.photoMsg.width
      ) {
        return false;
      }
      this.deltaWidth = this.deltaWidth ? this.deltaWidth : 0;
      const left =
        this.picLeft +
        this.deltaWidth -
        ((this.picScale - 1) *
          Math.floor(
            ((this.width - this.borderLeft - this.borderRight) / 2) * 100
          )) /
          100;
      const top =
        this.picTop +
        this.deltaHeight -
        ((this.picScale - 1) *
          Math.floor(
            ((this.height - this.borderTop - this.borderBottom) / 2) * 100
          )) /
          100;

      if (this.type == 1 || this.type == 9) {
        this.transpantPx = [0, 0, 0, 0];
      }
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale 
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.height / this.photoMsg.width) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];

          if (this.picLeft > maxX) {
            this.picLeft = maxX;
          } else if (this.picLeft <= minX) {
            this.picLeft = minX;
          }
          if (!this.picTop && this.picTop !== 0) {
            this.picTop = (maxY + minY) / 2
          } else {
            if (this.picTop >= maxY) {
              this.picTop = maxY;
            } else if (this.picTop <= minY) {
              this.picTop = minY;
            }
          }
          break;
        default:
          break;
      }
      this.deltaWidth =
        ((this.picScale - 1) *
          Math.floor(
            ((this.width - this.borderLeft - this.borderRight) / 2) * 100
          )) /
        100;
      this.deltaHeight =
        ((this.picScale - 1) *
          Math.floor(
            ((this.height - this.borderTop - this.borderBottom) / 2) * 100
          )) /
        100;
      this.originPhotoLeft = (
        ((this.photoMsg.height / this.photoMsg.width) *
          this.picScale *
          this.width) / 2
      );
      this.originPhotoTop =
        ((this.photoMsg.height / this.photoMsg.width) *
          this.picScale *
          this.width) / 2;


      

      this.$nextTick(() => {
        

        if (!state) {
          this.picLeft = (maxX + minX) / 2;
          this.picTop = (minY + maxY) / 2;
        }

        setTimeout(() => {
          this.checkRange('changePicScale');
          // if (this.type == 2) {
          //   this.resizeCanvas();
          // }
          this.$emit(
            "pmoving",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
        }, 20);
      });
    },
    unlock() {
      this.$emit("handleUnlock", this.dragIndex);
    },
    checkRange(o) {
      console.log(o)
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          console.log(
            this.height,
            this.photoMsg.height,
            this.picScale,
            this.photoMsg.width,
            this.photoMsg.width,
            31221111111111111111
          );
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];

          console.log(minY, this.transpantPx[3], 32131312);
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }
      this.range = {
        maxX,
        maxY,
        minX,
        minY,
      };
      console.log('checkrange',this.picTop,maxY,minY)
      if (this.picLeft > maxX) {
        this.picLeft = maxX;
      } else if (this.picLeft <= minX) {
        this.picLeft = minX;
      }
      if (!this.picTop && this.picTop !== 0) {
        this.picTop = (maxY + minY) / 2
      } else {
        if (this.picTop >= maxY) {
          this.picTop = maxY;
        } else if (this.picTop <= minY) {
          this.picTop = minY;
        }
      }
      
      console.log('checkrange',this.picTop)
      return {
        maxX,
        maxY,
        minX,
        minY,
      };
      
    },
    checkRange2() {
      console.log('照片边缘修正前',this.picLeft,this.picTop)
      let maxX = 0;
      let maxY = 0;
      let minX = 0;
      let minY = 0;
      let orginWidth = this.width - this.borderLeft - this.borderRight;
      let orginHeight = this.height - this.borderTop - this.borderBottom;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          maxX = (this.picWidth / 2) * (this.picScale - 1);
          maxY = (this.picHeight / 2) * (this.picScale - 1);
          minX =
            -((this.picWidth / 2) * (this.picScale - 1)) -
            (this.picWidth - orginWidth);
          minY =
            -((this.picHeight / 2) * (this.picScale - 1)) -
            (this.picHeight - orginHeight);
          break;
        case 90:
          maxX =
            (this.picHeight / 2) * (this.picScale - 1) -
            (this.picWidth - this.picHeight) / 2;
          maxY =
            (this.picWidth / 2) * (this.picScale - 1) -
            (this.picHeight - this.picWidth) / 2;
          minX =
            -((this.picHeight / 2) * (this.picScale - 1)) -
            (this.picHeight - orginWidth) -
            (this.picWidth - this.picHeight) / 2;
          minY =
            -((this.picWidth / 2) * (this.picScale - 1)) -
            (this.picWidth - orginHeight) -
            (this.picHeight - this.picWidth) / 2;
          break;
        case 180:
          maxX = (this.picWidth / 2) * (this.picScale - 1);
          maxY = (this.picHeight / 2) * (this.picScale - 1);
          minX =
            -((this.picWidth / 2) * (this.picScale - 1)) -
            (this.picWidth - orginWidth);
          minY =
            -((this.picHeight / 2) * (this.picScale - 1)) -
            (this.picHeight - orginHeight);
          break;
        case 270:
          maxX =
            (this.picHeight / 2) * (this.picScale - 1) -
            (this.picWidth - this.picHeight) / 2;
          maxY =
            (this.picWidth / 2) * (this.picScale - 1) -
            (this.picHeight - this.picWidth) / 2;
          minX =
            -((this.picHeight / 2) * (this.picScale - 1)) -
            (this.picHeight - orginWidth) -
            (this.picWidth - this.picHeight) / 2;
          minY =
            -((this.picWidth / 2) * (this.picScale - 1)) -
            (this.picWidth - orginHeight) -
            (this.picHeight - this.picWidth) / 2;
          break;
        default:
          break;
      }
      this.range = {
        maxX,
        maxY,
        minX,
        minY,
      };
      
      if (this.picLeft > maxX) {
        this.picLeft = maxX;
      } else if (this.picLeft <= minX) {
        this.picLeft = minX;
      }
      if (this.picTop >= maxY) {
        this.picTop = maxY;
      } else if (this.picTop <= minY) {
        this.picTop = minY;
      }
      console.log('照片边缘修正后',this.picLeft,this.picTop)
      return {
        maxX,
        maxY,
        minX,
        minY,
      };
    },
    exhcnageBr(val) {
      val = val ? val : ''
        if (this.type != 5 && this.type != 0 && this.type != 1) return "";
        let arr = [];
        val.split("<br/>").forEach((item) => arr.push(`${item}`));
        return arr.join("\n");
    },
    getHeight() {
      return this.height;
    },
    changeLevel(n) {
      if (!this.enabled) {
        return false;
      }
      this.$emit("changeLevel", n, this.dragIndex);
    },
    fangda() {
      clearTimeout(this.moveTimeState);
      this.moveState2 = true;
      this.moveTimeState = setTimeout(() => {
        this.moveState2 = false;
      }, 1000);
      if ((this.type == 1 || this.type == 9) && this.backgroundImg == "") {
        return false;
      }
      if (this.type == 2 && this.showPhoto == "") {
        return false;
      }
      if (this.picScale > 4) {
        setTimeout(() => {
          this.resizeCanvas();
        }, 20);
        return false;
      }

      this.picScale = Number(this.picScale) + 0.2;
      this.deltaScale = 0.2;
      this.changePicScale(true);
      // setTimeout(() => {
      //   this.moveState = false;
      //   this.$emit(
      //     "pmoving",
      //     this.picLeft,
      //     this.picTop,
      //     this.picRotate,
      //     parseFloat(this.picScale).toFixed(2),
      //     this.dragIndex
      //   );
      //   this.resizeCanvas();
      // }, 300);
    },
    resizeMovebox() {
      // var drag = this.$refs.drag.getBoundingClientRect()
      // this.moveboxTop = drag.top + drag.height / 2
      // this.moveboxLeft = drag.right - 30
    },
    start() {
      if (!this.enabled) {
        this.enabled = true;

        this.$emit("activated", this.dragIndex);
        this.$emit("update:active", true);
      }
    },
    end() {
      clearTimeout(this.looptime); //清空定时器，防止重复注册定时器
    },
    suoxiao() {
      clearTimeout(this.moveTimeState);
      this.moveState2 = true;
      this.moveTimeState = setTimeout(() => {
        this.moveState2 = false;
      }, 1000);
      if ((this.type == 1 || this.type == 9) && this.backgroundImg == "") {
        return false;
      }
      if (this.type == 2 && this.showPhoto == "") {
        return false;
      }
      var scale = Number(this.picScale) - 0.2;
      this.deltaScale = -0.2;
      if (scale <= this.minScale) {
        this.deltaScale = this.minScale - this.picScale;
        this.picScale = this.minScale;
        this.changePicScale();
        setTimeout(() => {
          this.resizeCanvas();
        }, 20);
        return false;
      }

      this.picScale = Number(this.picScale) - 0.2;
      this.changePicScale(true);

      // setTimeout(() => {
      //   this.moveState = false;
      //   this.$emit(
      //     "pmoving",
      //     this.picLeft,
      //     this.picTop,
      //     this.picRotate,
      //     parseFloat(this.picScale).toFixed(2),
      //     this.dragIndex
      //   );
      //   this.resizeCanvas();
      // }, 300);
    },
    getImageBoundRect(img) {
      return new Promise((resolve, reject) => {
        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var _ctx = canvas.getContext("2d");
        _ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          canvas.width,
          canvas.height
        );
        //裁剪空白区域
        var imgData = _ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var lOffset = canvas.width,
          rOffset = 0,
          tOffset = canvas.height,
          bOffset = 0;
        for (var i = 0; i < canvas.width; i++) {
          for (var j = 0; j < canvas.height; j++) {
            var pos = (i + canvas.width * j) * 4;
            if (imgData[pos + 3] > 0) {
              // 这个条件说第j行第i列的像素不是透明的
              bOffset = Math.max(j, bOffset); // 找到不透明区域最底部的纵坐标
              rOffset = Math.max(i, rOffset); // 找到不透明区域的最右端
              tOffset = Math.min(j, tOffset); // 找到不透明区域的最上端
              lOffset = Math.min(i, lOffset); // 找到不透明区域的最左端
            }
          }
        }
        // 由于循环是从0开始的,而我们认为的行列是从1开始的
        lOffset++;
        rOffset++;
        tOffset++;
        bOffset++;
        const p = img.width / (this.width - this.borderLeft - this.borderRight);
        this.transpantPx = [
          this.floor2(lOffset / p) - 2,
          this.floor2(tOffset / p) - 2,
          this.floor2((img.width - rOffset) / p) - 2,
          this.floor2((img.height - bOffset) / p) - 2,
        ];
        resolve();
      });
    },
    floor2(NUM) {
      return Math.floor(NUM * 100) / 100;
    },
    loadimg() { // 这里是画布复原相框逻辑，还有一次photoinitnew是初始化
      var that = this;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = this.backgroundImg;
      img.onload = (e) => {
        if (this.h == "auto" || !this.h) {
          this.height = (this.width / img.width) * img.height;
          this.$emit("changeHeight", this.height, this.dragIndex);
          this.bottom = this.parentHeight - this.height - this.top;
          this.aspectFactor = this.width / this.height;
        }

        if (this.type == 1) {
          // this.photoMsg = {
          //   width: img.width,
          //   height: img.height,
          // };
          this.photoMsg = {
            width: img.width,
            height: img.height,
          };
          this.resizePicScale3()
          this.changePicScale(true);
          this.originPhotoLeft = (
            ((1 - this.photoMsg.width / this.photoMsg.height) *
              this.picScale *
              this.width) /
            2
          );
          this.originPhotoTop =
            -((1 - this.photoMsg.width / this.photoMsg.height) *
              this.picScale *
              this.width) /
            2;
          return false;
        } else if (this.type == 9) { // 普通相框类型逻辑
          const orginWidth = that.width - that.borderLeft - that.borderRight; //去除border后的组件真实宽度
          const orginHeight = that.height - that.borderTop - that.borderBottom; //去除border后的组件真实高度
          const p =
            (that.width - that.borderLeft - that.borderRight) /
            (that.height - that.borderTop - that.borderBottom); // 组件宽高比
          let photoP;
          // var pw = img.width;
          // var ph = img.height;
          let picRotate = this.picRotate % 360;
          switch (picRotate) {
            case 0:
              this.photoMsg = {
                width: img.width,
                height: img.height,
              };
              photoP = this.photoMsg.width / this.photoMsg.height; // 照片宽高比
              if (p >= photoP) { // 组件长条形，照片竖条形
                this.picWidth = orginWidth;
                this.picHeight = (this.picWidth * img.height) / img.width;
              } else { // 组件竖条形，照片长条形
                this.picHeight = orginHeight;
                this.picWidth = (this.picHeight * img.width) / img.height;
              }
              break;
            case 90:
              this.photoMsg = {  // 旋转90度，照片宽高对调计算
                width: img.height,
                height: img.width,
              };
              photoP = this.photoMsg.width / this.photoMsg.height;
              if (p >= photoP) { // 组件长条形，照片竖条形
                this.picHeight = orginWidth;
                this.picWidth = (this.picHeight * img.width) / img.height;
              } else {// 组件竖条形，照片长条形
                this.picWidth = orginHeight;
                this.picHeight = (this.picWidth * img.height) / img.width;
              }
              break;
            case 180:
              this.photoMsg = {
                width: img.width,
                height: img.height,
              };
              photoP = this.photoMsg.width / this.photoMsg.height;
              if (p >= photoP) {
                this.picWidth = orginWidth;
                this.picHeight = (this.picWidth * img.height) / img.width;
              } else {
                this.picHeight = orginHeight;
                this.picWidth = (this.picHeight * img.width) / img.height;
              }
              break;
            case 270:
              this.photoMsg = {
                width: img.height,
                height: img.width,
              };
              photoP = this.photoMsg.width / this.photoMsg.height;
              if (p >= photoP) {
                this.picHeight = orginWidth;
                this.picWidth = (this.picHeight * img.width) / img.height;
              } else {
                this.picWidth = orginHeight;
                this.picHeight = (this.picWidth * img.height) / img.width;
              }
              break;
            default:
              break;
          }
          this.$forceUpdate();
          this.checkRange2();
          return false;
        }

        try {
          var mask = new Image();
          mask.setAttribute("crossOrigin", "Anonymous");
          mask.src = this.backimg2;
          mask.onload = () => {
            this.getImageBoundRect(mask);
            if (this.showPhoto) {
              var photo = new Image();
              photo.setAttribute("crossOrigin", "Anonymous");
              photo.src = this.showPhoto;
              photo.onload = (e) => {
                this.photoMsg = {
                  width: photo.width,
                  height: photo.height,
                };

                var that = this;
                if (
                  photo.width / photo.height >
                  (that.width - this.transpantPx[0] - this.transpantPx[2]) /
                    (that.height - this.transpantPx[1] - this.transpantPx[3])
                ) {
                  this.minScale =
                    ((((photo.width / photo.height) * that.height) /
                      that.width) *
                      (that.height -
                        this.transpantPx[1] -
                        this.transpantPx[3])) /
                    this.height;
                    // if (this.minScale > this.picScale) {
                    //   let picRotate = this.picRotate % 360;
                    //   switch (picRotate) {
                    //     case 0:
                    //       this.calcPicScale(photo);
                    //       break;
                    //     case 90:
                    //       this.calcPicScale2(photo);
                    //     case 180:
                    //       this.calcPicScale(photo);
                    //     case 270:
                    //       this.calcPicScale2(photo);
                    //     default:
                    //       break;
                    //   }
                    //   return false
                    // }
                  // this.checkRange();   
                } else {
                  this.minScale =
                    (that.width - this.transpantPx[0] - this.transpantPx[2]) /
                    this.width;
                    // if (this.minScale > this.picScale) {
                    //   let picRotate = this.picRotate % 360;
                    //   switch (picRotate) {
                    //     case 0:
                    //       this.calcPicScale(photo);
                    //       break;
                    //     case 90:
                    //       this.calcPicScale2(photo);
                    //     case 180:
                    //       this.calcPicScale(photo);
                    //     case 270:
                    //       this.calcPicScale2(photo);
                    //     default:
                    //       break;
                    //   }
                    //   return false
                    // }
                  // this.checkRange();
                }
              };
            }

            return false;
            var canvas = document.getElementById(
              this.frameId ? "frame" + this.frameId : "frame" + this.dragIndex
            );
            var context = canvas.getContext("2d");
            canvas.height = canvas.height;
            context.drawImage(mask, 0, 0, this.width, this.height);
            img.onload = () => {
              if (this.showPhoto) {
                var photo = new Image();
                photo.setAttribute("crossOrigin", "Anonymous");
                photo.src = this.showPhoto;
                photo.onload = (e) => {
                  this.photoMsg = {
                    width: photo.width,
                    height: photo.height,
                  };
                  context.globalCompositeOperation = "source-in";
                  // context.translate(this.width / 2, this.height / 2);
                  // context.rotate((this.picRotate * Math.PI) / 180);
                  // context.translate(-this.width / 2, -this.height / 2);
                  context.drawImage(
                    photo,
                    (-this.picLeft * photo.width) / this.width / this.picScale,
                    (-this.picTop * photo.width) / this.width / this.picScale,
                    photo.width / this.picScale,
                    ((photo.width / this.picScale) * this.height) / this.width,
                    0,
                    0,
                    this.width,
                    this.height
                  );
                  context.translate(this.width / 2, this.height / 2);
                  context.rotate((-this.picRotate * Math.PI) / 180);
                  context.translate(-this.width / 2, -this.height / 2);
                  // context.restore()
                  context.globalCompositeOperation = "source-over";
                  // 绘制装饰图
                  context.drawImage(img, 0, 0, this.width, this.height);
                  // this.canvasImg = canvas.toDataURL("image/png");
                };
              } else {
                // 设置混合模式为滤色
                context.globalCompositeOperation = "source-over";
                // 绘制装饰图
                context.drawImage(img, 0, 0, this.width, this.height);
                // this.canvasImg = canvas.toDataURL("image/png");
                // 登录状态下不会出现这行文字，点击页面右上角一键登录
              }
            };
          };
        } catch (error) {}
      };
    },
    resizePicScale3() {
      var that = this;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = that.backgroundImg;
      img.onload = (e) => {
        console.log("这是普通照片的信息，第二处");
        var pw = img.width;
        var ph = img.height;
        switch (this.picRotate) {
          case 0:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            break;
          case 90:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            break;
          case 180:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            break;
          case 270:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            break;
          default:
            break;
        }
        switch (this.picRotate) {
          case 0:
            let s1 = Math.floor((img.width * (that.height - that.borderTop - that.borderBottom) / (that.width - that.borderLeft - that.borderRight) / img.height) * 100) / 100
            this.minScale = s1 > 1 ? s1 : 1
            if (this.picScale < this.minScale) {
              this.picScale = this.minScale;
            }
            break;
          case 90:
            s1 = Math.floor((img.width / img.height) * 100) / 100
            let s2 = Math.floor(((that.height - that.borderTop - that.borderBottom) / (that.width - that.borderLeft - that.borderRight)) * 100) / 100
            this.minScale = s1 > s2 ? s1 : s2
            if (this.picScale < this.minScale) {
              this.picScale = this.minScale;
            }
            break;
          case 180:
            s1 = Math.floor((img.width * (that.height - that.borderTop - that.borderBottom) / (that.width - that.borderLeft - that.borderRight) / img.height) * 100) / 100
            this.minScale = s1 > 1 ? s1 : 1
            if (this.picScale < this.minScale) {
              this.picScale = this.minScale;
            }
            break;
          case 270:
            s1 = Math.floor((img.width / img.height) * 100) / 100
            s2 = Math.floor(((that.height - that.borderTop - that.borderBottom) / (that.width - that.borderLeft - that.borderRight)) * 100) / 100
            this.minScale = s1 > s2 ? s1 : s2
            if (this.picScale < this.minScale) {
              this.picScale = this.minScale;
            }
            break;
          default:
            break;
        }
      };
    },
    matchText() {
      // var str = this.text
      //   console.log(str)
      // if (this.fontFamily) {
      //   str = str.replace(/ql-font-[\u4e00-\u9fa5\w]+[\s]*?/ig,"")
      // }
      // if (this.fontColor ) {
      //   str =  str.replace(/color:[\s]*rgb\(.+?\)[\s]*?;/ig,"");
      // }
      // if (this.fontSize && this.fontSize != 0) {
      //   str = str.replace(/ql-size-[0-9]+px[\s]*?/ig,"")
      // }
      // this.content = str
      // this.$forceUpdate()
    },
    initPhotoNew(state) { //照片更新，或者旋转后的逻辑
      var that = this;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = that.backgroundImg;
      img.onload = (e) => {
        const orginWidth = that.width - that.borderLeft - that.borderRight; // 组件实际宽度
        const orginHeight = that.height - that.borderTop - that.borderBottom;// 组件实际高度
        const p =   // 组件宽高比
          (that.width - that.borderLeft - that.borderRight) /
          (that.height - that.borderTop - that.borderBottom);
        let photoP;
        // var pw = img.width;
        // var ph = img.height;
        let picRotate = this.picRotate % 360; 
        switch (picRotate) {
          case 0:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picWidth = orginWidth;
              this.picHeight = (this.picWidth * img.height) / img.width;
            } else {
              this.picHeight = orginHeight;
              this.picWidth = (this.picHeight * img.width) / img.height;
            }
            // this.originPhotoLeft =
            //   this.picScale == 1
            //     ? -((this.picWidth * (this.picScale - 1)) / 2)
            //     : 0;
            // this.originPhotoTop =
            //   this.picScale == 1
            //     ? -((this.picHeight * (this.picScale - 1)) / 2)
            //     : 0;
            this.picLeft = -((this.picWidth - orginWidth) / 2);
            this.picTop = -((this.picHeight - orginHeight) / 2);

            break;
          case 90:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picHeight = orginWidth;
              this.picWidth = (this.picHeight * img.width) / img.height;
            } else {
              this.picWidth = orginHeight;
              this.picHeight = (this.picWidth * img.height) / img.width;
            }

            // this.originPhotoLeft =
            //   this.picScale == 1
            //     ? -((this.picHeight * (this.picScale - 1)) / 2)
            //     : 0;
            // this.originPhotoTop =
            //   this.picScale == 1
            //     ? -((this.picWidth * (this.picScale - 1)) / 2)
            //     : 0;
            this.picLeft = -((this.picWidth - orginWidth) / 2); //因为旋转导致的偏差纠正   注意，这里面只有一个偏差，另外一个偏差携带居中
            this.picTop = -((this.picHeight - orginHeight) / 2);//因为旋转导致的偏差纠正
            break;
          case 180:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picWidth = orginWidth;
              this.picHeight = (this.picWidth * img.height) / img.width;
            } else {
              this.picHeight = orginHeight;
              this.picWidth = (this.picHeight * img.width) / img.height;
            }
            // this.originPhotoLeft =
            //   this.picScale == 1
            //     ? -((this.picWidth * (this.picScale - 1)) / 2)
            //     : 0;
            // this.originPhotoTop =
            //   this.picScale == 1
            //     ? -((this.picHeight * (this.picScale - 1)) / 2)
            //     : 0;
            this.picLeft = -((this.picWidth - orginWidth) / 2);
            this.picTop = -((this.picHeight - orginHeight) / 2);
            break;
          case 270:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picHeight = orginWidth;
              this.picWidth = (this.picHeight * img.width) / img.height;
            } else {
              this.picWidth = orginHeight;
              this.picHeight = (this.picWidth * img.height) / img.width;
            }
            // this.originPhotoLeft =
            //   this.picScale == 1
            //     ? -((this.picHeight * (this.picScale - 1)) / 2)
            //     : 0;
            // this.originPhotoTop =
            //   this.picScale == 1
            //     ? -((this.picWidth * (this.picScale - 1)) / 2)
            //     : 0;
            this.picLeft = -((this.picWidth - orginWidth) / 2);
            this.picTop = -((this.picHeight - orginHeight) / 2);
            break;
          default:
            break;
        }
        if (state) {
          this.picScale = 1;
          this.$emit(
            "photoChange",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
        }
        this.checkRange2();
        this.$forceUpdate();
      };
    },
    reinitPhoto() {
      var that = this;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = that.backgroundImg;
      img.onload = (e) => {
        const orginWidth = that.width - that.borderLeft - that.borderRight;
        const orginHeight = that.height - that.borderTop - that.borderBottom;
        const p =
          (that.width - that.borderLeft - that.borderRight) /
          (that.height - that.borderTop - that.borderBottom);
        let photoP;
        // var pw = img.width;
        // var ph = img.height;
        let picRotate = this.picRotate % 360;
        switch (picRotate) {
          case 0:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picWidth = orginWidth;
              this.picHeight = (this.picWidth * img.height) / img.width;
            } else {
              this.picHeight = orginHeight;
              this.picWidth = (this.picHeight * img.width) / img.height;
            }
            // this.picLeft = -((this.picWidth - orginWidth ) / 2)
            // this.picTop = -((this.picHeight - orginHeight ) / 2)
            this.originPhotoLeft =
              this.picScale == 1
                ? -((this.picWidth * (this.picScale - 1)) / 2)
                : 0;
            this.originPhotoTop =
              this.picScale == 1
                ? -((this.picHeight * (this.picScale - 1)) / 2)
                : 0;
            break;
          case 90:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picHeight = orginWidth;
              this.picWidth = (this.picHeight * img.width) / img.height;
            } else {
              this.picWidth = orginHeight;
              this.picHeight = (this.picWidth * img.height) / img.width;
            }
            // this.picLeft = -((this.picWidth - orginWidth ) / 2)
            // this.picTop = -((this.picHeight - orginHeight ) / 2)
            this.originPhotoLeft =
              this.picScale == 1
                ? -((this.picHeight * (this.picScale - 1)) / 2)
                : 0;
            this.originPhotoTop =
              this.picScale == 1
                ? -((this.picWidth * (this.picScale - 1)) / 2)
                : 0;
            break;
          case 180:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picWidth = orginWidth;
              this.picHeight = (this.picWidth * img.height) / img.width;
            } else {
              this.picHeight = orginHeight;
              this.picWidth = (this.picHeight * img.width) / img.height;
            }
            // this.picLeft = -((this.picWidth - orginWidth ) / 2)
            // this.picTop = -((this.picHeight - orginHeight ) / 2)
            this.originPhotoLeft =
              this.picScale == 1
                ? -((this.picWidth * (this.picScale - 1)) / 2)
                : 0;
            this.originPhotoTop =
              this.picScale == 1
                ? -((this.picHeight * (this.picScale - 1)) / 2)
                : 0;
            break;
          case 270:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            photoP = this.photoMsg.width / this.photoMsg.height;
            if (p >= photoP) {
              this.picHeight = orginWidth;
              this.picWidth = (this.picHeight * img.width) / img.height;
            } else {
              this.picWidth = orginHeight;
              this.picHeight = (this.picWidth * img.height) / img.width;
            }
            // this.picLeft = -((this.picWidth - orginWidth ) / 2)
            // this.picTop = -((this.picHeight - orginHeight ) / 2)
            this.originPhotoLeft =
              this.picScale == 1
                ? -((this.picHeight * (this.picScale - 1)) / 2)
                : 0;
            this.originPhotoTop =
              this.picScale == 1
                ? -((this.picWidth * (this.picScale - 1)) / 2)
                : 0;
            break;
          default:
            break;
        }
        this.$forceUpdate();
        this.checkRange2();
        this.$emit(
          "resizing",
          this.picLeft,
          this.picTop,
          this.picRotate,
          parseFloat(this.picScale).toFixed(4),
          this.dragIndex
        );
      };
    },
    resizePicScale() {
      var that = this;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = that.backgroundImg;
      img.onload = (e) => {
        // var pw = img.width;
        // var ph = img.height;
        let picRotate = this.picRotate % 360;
        switch (picRotate) {
          case 0:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            break;
          case 90:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            break;
          case 180:
            this.photoMsg = {
              width: img.width,
              height: img.height,
            };
            break;
          case 270:
            this.photoMsg = {
              width: img.height,
              height: img.width,
            };
            break;
          default:
            break;
        }
        let picRotate2 = this.picRotate % 360;
        switch (picRotate2) {
          case 0:
            let s1 =
              (((img.width *
                (that.height - that.borderTop - that.borderBottom)) /
                (that.width - that.borderLeft - that.borderRight) /
                img.height) *
                100) /
              100;
            this.picScale = s1 > 1 ? s1 : 1;
            this.minScale = this.picScale;
            if (this.type == 2) {
              let s1 =
                ((Math.floor(
                  ((img.width *
                    (that.height - that.borderTop - that.borderBottom)) /
                    (that.width - that.borderLeft - that.borderRight) /
                    img.height) *
                    100
                ) /
                  100) *
                  (that.width -
                    that.borderLeft -
                    that.borderRight -
                    this.transpantPx[1] -
                    this.transpantPx[3])) /
                (that.width - that.borderLeft - that.borderRight);
              this.picScale = s1;
              this.minScale = this.picScale;
            }
            break;
          case 90:
            s1 = ((img.width / img.height) * 100) / 100 + 0.1;
            let s2 =
              (((that.height - that.borderTop - that.borderBottom) /
                (that.width - that.borderLeft - that.borderRight)) *
                100) /
                100 +
              0.1;
            this.picScale = s1 > s2 ? s1 : s2;
            this.minScale = this.picScale;
            break;
          case 180:
            s1 =
              (((img.width *
                (that.height - that.borderTop - that.borderBottom)) /
                (that.width - that.borderLeft - that.borderRight) /
                img.height) *
                100) /
              100;
            this.picScale = s1 > 1 ? s1 : 1;
            this.minScale = this.picScale;
            break;
          case 270:
            s1 = ((img.width / img.height) * 100) / 100 + 0.1;
            s2 =
              (((that.height - that.borderTop - that.borderBottom) /
                (that.width - that.borderLeft - that.borderRight)) *
                100) /
                100 +
              0.1;
            this.picScale = s1 > s2 ? s1 : s2;
            this.minScale = this.picScale;
            break;
          default:
            break;
        }
        this.changePicScale();
        this.resizePicScale2();
      };
    },
    resizePicScale2() {
      this.deltaWidth = this.deltaWidth ? this.deltaWidth : 0;
      if (this.type == 1 || this.type == 9) {
        this.transpantPx = [0, 0, 0, 0];
      }
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }

      this.$nextTick(() => {
        this.picLeft = (maxX + minX) / 2;
        this.picTop = (maxY + minY) / 2;
        // this.picLeft = (this.picLeft + this.deltaWidth) - (this.picScale - 1) * Math.floor((this.width - this.borderLeft - this.borderRight) / 2 * 100) / 100;
        // this.picTop = (this.picTop + this.deltaHeight) - (this.picScale - 1) * Math.floor((this.height - this.borderTop - this.borderBottom) / 2 * 100) / 100;
        this.deltaWidth = (
          ((this.picScale - 1) *
            Math.floor(
              ((this.width - this.borderLeft - this.borderRight) / 2) * 100
            )) /
          100
        ).toFixed(4);
        this.deltaHeight = (
          ((this.picScale - 1) *
            Math.floor(
              ((this.height - this.borderTop - this.borderBottom) / 2) * 100
            )) /
          100
        ).toFixed(4);
        this.originPhotoLeft = -(
          ((1 - this.photoMsg.width / this.photoMsg.height) *
            this.picScale *
            this.width) /
          2
        );
        this.originPhotoTop =
          ((1 - this.photoMsg.width / this.photoMsg.height) *
            this.picScale *
            this.width) /
          2;
        setTimeout(() => {
          this.moveState = false;
          this.$emit(
            "pmoving",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
          this.checkRange('resizePicScale2');
          if (this.type == 2) {
            this.resizeCanvas();
          }
        }, 20);
      });
    },
    calcPicScale(photo) {
      if (this.type == 1 || this.type == 9) {
        this.transpantPx = [0, 0, 0, 0];
      }
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.picLeft = (maxX + minX) / 2;
        this.picTop = (maxY + minY) / 2;

        var that = this;
        if (
          photo.width / photo.height >
          (that.width - this.transpantPx[0] - this.transpantPx[2]) /
            (that.height - this.transpantPx[1] - this.transpantPx[3])
        ) {
          // this.picScale =
          //   ((photo.width / photo.height) * that.height) / that.width * (that.height - this.transpantPx[1] - this.transpantPx[3] ) / this.height;
          // this.minScale = this.picScale;
          this.picScale =
            ((((photo.width / photo.height) * that.height) / that.width) *
              (that.height - this.transpantPx[1] - this.transpantPx[3])) /
            this.height;
          this.minScale = this.picScale;
          this.changePicScale();
          // this.$emit(
          //   "photoChange",
          //   this.picLeft,
          //   this.picTop,
          //   this.picRotate,
          //   parseFloat(this.picScale.toFixed(4)),
          //   this.dragIndex
          // );
        } else {
          this.picScale =
            (that.width - this.transpantPx[0] - this.transpantPx[2]) /
            this.width;
          this.minScale = this.picScale;
          this.changePicScale();
          // this.$emit(
          //   "photoChange",
          //   this.picLeft,
          //   this.picTop,
          //   this.picRotate,
          //   parseFloat(this.picScale).toFixed(4),
          //   this.dragIndex
          // );
        }
      });
    },
    calcPicScale2(photo) {
      var that = this;
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.picLeft = (maxX + minX) / 2;
        this.picTop = (maxY + minY) / 2;

        if (photo.height / photo.width > that.width / that.height) {
          this.picScale =
            ((photo.height / photo.width) * that.height) / that.width;
          this.minScale = this.picScale;
          this.changePicScale();
          if (this.type == 2) {
            this.checkRange('calcPicScale2');
          }
          this.$emit(
            "photoChange",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale.toFixed(4)),
            this.dragIndex
          );
        } else {
          if (this.type == 2) {
            this.checkRange('calcPicScale2');
          }
          this.$emit(
            "photoChange",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
        }
      });
    },
    resizingCalcPicScale() {
      let photo = this.photoMsg;
      if (this.type == 1 || this.type == 9) {
        this.transpantPx = [0, 0, 0, 0];
      }
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }
      var that = this;
      if (
        photo.width / photo.height >
        (that.width - this.transpantPx[0] - this.transpantPx[2]) /
          (that.height - this.transpantPx[1] - this.transpantPx[3])
      ) {
        // this.picScale =
        //   ((photo.width / photo.height) * that.height) / that.width * (that.height - this.transpantPx[1] - this.transpantPx[3] ) / this.height;
        // this.minScale = this.picScale;
        const picScale =
          ((((photo.width / photo.height) * that.height) / that.width) *
            (that.height - this.transpantPx[1] - this.transpantPx[3])) /
          this.height;
        this.minScale = picScale;
        if (this.picScale < picScale) {
          this.picScale = picScale;
          this.changePicScale();
        }
        this.checkRange('resizingCalcPicScale');
      } else {
        const picScale =
          (that.width - this.transpantPx[0] - this.transpantPx[2]) / this.width;
        this.minScale = picScale;
        this.checkRange('resizingCalcPicScale');
        if (this.picScale < picScale) {
          this.picScale = picScale;
          this.changePicScale();
        }
      }
    },
    resizingCalcPicScale2(photo) {
      var that = this;
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.picLeft = (maxX + minX) / 2;
        this.picTop = (maxY + minY) / 2;

        if (photo.height / photo.width > that.width / that.height) {
          this.picScale =
            ((photo.height / photo.width) * that.height) / that.width;
          this.minScale = this.picScale;
          this.changePicScale();
          this.$emit(
            "pmoving",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale.toFixed(4)),
            this.dragIndex
          );
        } else {
          this.$emit(
            "pmoving",
            this.picLeft,
            this.picTop,
            this.picRotate,
            parseFloat(this.picScale).toFixed(4),
            this.dragIndex
          );
        }
      });
    },
    resizeCanvas(state) {
      var that = this;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = this.backgroundImg;
      img.onload = async (e) => {
        if (this.h == "auto" || !this.h) {
          this.height = (this.width / img.width) * img.height;
          this.bottom = this.parentHeight - this.height - this.top;
          this.aspectFactor = this.width / this.height;
        }
        await this.snapCheck();
        if (state) {
        var mask = new Image();
        mask.setAttribute("crossOrigin", "Anonymous");
        mask.src = this.backimg2;
        mask.onload = () => {
          this.getImageBoundRect(mask).then(()=>{
            if (this.showPhoto) {
            var photo = new Image();
            photo.setAttribute("crossOrigin", "Anonymous");
            photo.src = this.showPhoto;
            photo.onload = (e) => {
              this.photoMsg = {
                width: photo.width,
                height: photo.height,
              };

              let picRotate = this.picRotate % 360;
              switch (picRotate) {
                case 0:
                  this.calcPicScale(photo);
                  break;
                case 90:
                  this.calcPicScale2(photo);
                case 180:
                  this.calcPicScale(photo);
                case 270:
                  this.calcPicScale2(photo);
                default:
                  break;
              }
            };
          }
          })

          
        };
      }
      }
      

      return false;
      try {
        var mask = new Image();
        mask.setAttribute("crossOrigin", "Anonymous");
        mask.src = this.backimg2;
        mask.onload = () => {
          var img = new Image();
          img.setAttribute("crossOrigin", "Anonymous");
          img.src = that.backgroundImg;
          var canvas = document.getElementById(
            this.frameId ? "frame" + this.frameId : "frame" + this.dragIndex
          );
          var context = canvas.getContext("2d");
          canvas.height = canvas.height;
          context.drawImage(mask, 0, 0, that.width, that.height);
          img.onload = () => {
            if (this.showPhoto) {
              var photo = new Image();
              photo.setAttribute("crossOrigin", "Anonymous");
              photo.src = this.showPhoto;
              photo.onload = (e) => {
                this.photoMsg = {
                  width: photo.width,
                  height: photo.height,
                };
                if (state) {
                  let picRotate = this.picRotate % 360;
                  switch (picRotate) {
                    case 0:
                      this.calcPicScale(photo);
                      break;
                    case 90:
                      this.calcPicScale2(photo);
                    case 180:
                      this.calcPicScale(photo);
                    case 270:
                      this.calcPicScale2(photo);
                    default:
                      break;
                  }
                }
                context.globalCompositeOperation = "source-in";
                // context.translate(this.width / 2, this.height / 2);
                // context.rotate((this.picRotate * Math.PI) / 180);
                // context.translate(-this.width / 2, -this.height / 2);
                context.drawImage(
                  photo,
                  (-this.picLeft * photo.width) / this.width / this.picScale,
                  (-this.picTop * photo.width) / this.width / this.picScale,
                  photo.width / this.picScale,
                  ((photo.width / this.picScale) * this.height) / this.width,
                  0,
                  0,
                  this.width,
                  this.height
                );
                // context.translate(this.width / 2, this.height / 2);
                // context.rotate((-this.picRotate * Math.PI) / 180);
                // context.translate(-this.width / 2, -this.height / 2);
                // context.restore()
                context.globalCompositeOperation = "source-over";
                // 绘制装饰图
                context.drawImage(img, 0, 0, this.width, this.height);
                // this.canvasImg = canvas.toDataURL("image/png");
              };
            } else {
              // 设置混合模式为滤色
              context.globalCompositeOperation = "source-over";
              // 绘制装饰图
              context.drawImage(img, 0, 0, that.width, that.height);
              // this.canvasImg = canvas.toDataURL("image/png");
              // 登录状态下不会出现这行文字，点击页面右上角一键登录
            }
          };
        };
      } catch (error) {}
    },
    showEdit() {
      if (this.type == 1 || this.type == 0)
        this.$emit("showEdit", this.dragIndex);
    },
    showEdit2() {
      this.editState = true;
    },
    handleRotateUp() {
      this.originR = this.rotate;
    },
    getVal(parm) {
      if (parm == "height" && this.$refs.backRef) {
        return _.ceil(this.$refs.backRef.height);
      } else {
        return _.ceil(this[parm]);
      }
    },
    handleConfirmComb() {
      this.$emit("confirmComb", this.dragIndex, false);
    },
    handleMouseEnter() {
      this.$emit("mouseEnter", this.dragIndex, this.zIndex);
    },
    handleMouseLeave() {
      this.$emit("mouseLeave", this.dragIndex, this.zIndex);
    },
    elementMouseEnter() {},
    changeBorderStyle(e) {
      this.bStyle = e.target.value;
    },
    remove(dragIndex) {
      this.$emit("removeDrag", dragIndex);
    },
    changeBordercolor(e) {
      this.selectColor = false;
    },
    changeBcolor(e) {
      this.selectColor = false;
    },
    // 重置边界和鼠标状态
    resetBoundsAndMouseState() {
      this.mouseClickPosition = {
        mouseX: 0,
        mouseY: 0,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      };

      this.bounds = {
        minLeft: null,
        maxLeft: null,
        minRight: null,
        maxRight: null,
        minTop: null,
        maxTop: null,
        minBottom: null,
        maxBottom: null,
      };
    },
    changeBorder(type) {
      switch (type) {
        case "addleft":
          this.bLeft++;
          break;
        case "minleft":
          if (this.bLeft == 0) return false;
          this.bLeft--;
          break;
        case "addtop":
          this.bTop++;
          break;
        case "mintop":
          if (this.bTop == 0) return false;
          this.bTop--;
          break;
        case "addright":
          this.bRight++;
          break;
        case "minright":
          if (this.bRight == 0) return false;
          this.bRight--;
          break;
        case "addbottom":
          this.bBottom++;
          break;
        case "minbottom":
          if (this.bBottom == 0) return false;
          this.bBottom--;
          break;
        default:
          break;
      }
    },
    upIndex(dragIndex) {
      this.$emit("changeIndex", { dragIndex: dragIndex, type: "upIndex" });
    },
    downIndex(dragIndex) {
      this.$emit("changeIndex", { dragIndex: dragIndex, type: "downIndex" });
    },
    upTop(dragIndex) {
      this.$emit("changeIndex", { dragIndex: dragIndex, type: "upTop" });
    },
    downBottom(dragIndex) {
      this.$emit("changeIndex", { dragIndex: dragIndex, type: "downBottom" });
    },
    // 检查父元素大小
    checkParentSize() {
      if (this.parent) {
        const [newParentWidth, newParentHeight] = this.getParentSize();
        // 修复父元素改变大小后，组件resizing时活动异常
        this.right = newParentWidth - this.width - this.left;
        this.bottom = newParentHeight - this.height - this.top;

        this.parentWidth = newParentWidth;
        this.parentHeight = newParentHeight;
      }
    },
    // 获取父元素大小
    getParentSize() {
      if (this.parent === true) {
        const style = window.getComputedStyle(this.$el.parentNode, null);
        return [
          parseInt(style.getPropertyValue("width"), 10),
          parseInt(style.getPropertyValue("height"), 10),
        ];
      }
      if (typeof this.parent === "string") {
        const parentNode = document.querySelector(this.parent);
        if (!(parentNode instanceof HTMLElement)) {
          throw new Error(
            `The selector ${this.parent} does not match any element`
          );
        }
        return [parentNode.offsetWidth, parentNode.offsetHeight];
      }

      return [null, null];
    },
    // 元素触摸按下
    elementTouchDown(e) {
      eventsFor = events.touch;
      this.elementDown(e);
    },
    elementMouseDown(e) {
      eventsFor = events.mouse;

      this.elementDown(e);
    },
    handleEditState() {
      if (!this.isEdit) return false;
      this.editState = true;
      this.dragging = false;
      // this.originText = this.text;
      // const index = this.text.indexOf("请输入文字");
      // const index2 = this.text.indexOf("文本框");
      // if (index > -1 || index2 > -1) {
      //   this.content = "";
      // }
      this.$nextTick(() => {
        this.$refs.textarea.select();
      });
    },
    cancelActive() {
      this.enabled = false;
    },
    // 元素按下
    elementDown(e) {
      if (this.editState) return false;
      if (e instanceof MouseEvent && e.which !== 1) {
        return;
      }
      const target = e.target || e.srcElement;

      if (this.$el.contains(target)) {
        if (this.onDragStart(e) === false) {
          return;
        }

        if (
          (this.dragHandle &&
            !matchesSelectorToParentElements(
              target,
              this.dragHandle,
              this.$el
            )) ||
          (this.dragCancel &&
            matchesSelectorToParentElements(target, this.dragCancel, this.$el))
        ) {
          this.dragging = false;

          return;
        }

        if (!this.enabled) {
          this.enabled = true;

          this.$emit("activated", this.dragIndex);
          this.$emit("update:active", true);
        }

        this.dragging = this.draggable;

        this.mouseClickPosition.mouseX = e.touches
          ? e.touches[0].pageX
          : e.pageX;
        this.mouseClickPosition.mouseY = e.touches
          ? e.touches[0].pageY
          : e.pageY;

        this.mouseClickPosition.left = this.left;
        this.mouseClickPosition.right = this.right;
        this.mouseClickPosition.top = this.top;
        this.mouseClickPosition.bottom = this.bottom;
        this.mouseClickPosition.w = this.width;
        this.mouseClickPosition.h = this.height;
        this.orignPicLeft = this.picLeft;
        this.orignPicTop = this.picTop;
        if (this.parent) {
          this.bounds = this.calcDragLimits();
        }
        if (this.listen) {
          addEvent(document.documentElement, eventsFor.move, this.move);
          addEvent(document.documentElement, eventsFor.stop, this.handleUp);
        }
      }
    },
    // 计算移动范围
    calcDragLimits() {
      return {
        minLeft: this.left % this.grid[0],
        maxLeft:
          Math.floor(
            (this.parentWidth - this.width - this.left) / this.grid[0]
          ) *
            this.grid[0] +
          this.left,
        minRight: this.right % this.grid[0],
        maxRight:
          Math.floor(
            (this.parentWidth - this.width - this.right) / this.grid[0]
          ) *
            this.grid[0] +
          this.right,
        minTop: this.top % this.grid[1],
        maxTop:
          Math.floor(
            (this.parentHeight - this.height - this.top) / this.grid[1]
          ) *
            this.grid[1] +
          this.top,
        minBottom: this.bottom % this.grid[1],
        maxBottom:
          Math.floor(
            (this.parentHeight - this.height - this.bottom) / this.grid[1]
          ) *
            this.grid[1] +
          this.bottom,
      };
    },
    activeDrag() {
      if (!this.enabled) {
        this.enabled = true;
        this.orignPicLeft = this.picLeft;
        this.orignPicTop = this.picTop;

        if (this.parent) {
          this.bounds = this.calcDragLimits();
        }
        if (this.type == 11) {
          const [parentWidth, parentHeight] = this.getParentSize();

          this.parentWidth = parentWidth;
          this.parentHeight = parentHeight;
          let [width, height] = getComputedSize(this.$el);
          if (this.$refs.backRef && (!this.h || this.h == "auto")) {
            height = (height * this.w) / width;
          } else {
            height = this.h;
          }
          this.aspectFactor =
            (this.w !== "auto" ? parseInt(this.w) : width) /
            (this.h !== "auto" && this.h ? parseInt(this.h) : height);
          this.width = this.w !== "auto" ? parseInt(this.w) : width;
          this.height = this.h !== "auto" && this.h ? parseInt(this.h) : height;
          this.right = this.parentWidth - this.width - this.left;
          this.bottom = this.parentHeight - this.height - this.top;
          // this.$emit('resizeHeight',this.height,this.dragIndex)
          this.settingAttribute();
        }
        if (this.listen) {
          addEvent(document.documentElement, eventsFor.move, this.move);
          addEvent(document.documentElement, eventsFor.stop, this.handleUp);
        }
      }
    },
    // 取消
    deselect(e) {
      console.log("deslect");
      if (!this.enabled) {
        this.editState = false;
      } else {
        setTimeout(() => {
          if (!this.enabled) {
            this.editState = false;
          }
        }, 40);
      }
      const target = e.target || e.srcElement;
      const regex = new RegExp(this.className + "-([trmbl]{2})", "");
      if (this.selectColor) {
        return false;
      }
      if (!this.$el.contains(target) && !regex.test(target.className)) {
        if (this.enabled && !this.preventDeactivation) {
          this.enabled = false;

          this.$emit("deactivated", this.dragIndex);
          this.$emit("update:active", false);
        }

        removeEvent(
          document.documentElement,
          eventsFor.move,
          this.handleResize
        );

        
      }
      if (!this.showDrag) {
        removeEvent(
          document.documentElement,
          eventsFor.move,
          this.move
        );
      }
      this.resetBoundsAndMouseState();
    },
    // 控制柄触摸按下
    handleTouchDown(handle, e) {
      eventsFor = events.touch;

      this.handleDown(handle, e);
    },
    handleMove(handle, e) {
      console.log("122321312");
    },
    // 控制柄按下
    handleDown(handle, e) {
      if (e instanceof MouseEvent && e.which !== 1) {
        return;
      }

      if (this.onResizeStart(handle, e) === false) {
        return;
      }

      if (e.stopPropagation) e.stopPropagation();

      // Here we avoid a dangerous recursion by faking
      // corner handles as middle handles
      if (this.lockAspectRatio && !handle.includes("m")) {
        this.handle = "m" + handle.substring(1);
      } else {
        this.handle = handle;
      }

      this.resizing = true;

      this.mouseClickPosition.mouseX = e.touches ? e.touches[0].pageX : e.pageX;
      this.mouseClickPosition.mouseY = e.touches ? e.touches[0].pageY : e.pageY;
      this.mouseClickPosition.left = this.left;
      this.mouseClickPosition.right = this.right;
      this.mouseClickPosition.top = this.top;
      this.mouseClickPosition.bottom = this.bottom;
      this.mouseClickPosition.w = this.width;
      this.mouseClickPosition.h = this.height;

      this.bounds = this.calcResizeLimits();
      this.orginWidth = this.width - this.borderLeft - this.borderRight;
      this.orginHeight = this.height - this.borderTop - this.borderBottom;
      this.orginBorderRadius = this.borderRadius
      this.orginPicLeft = this.picLeft;
      this.orginPicTop = this.picTop;
      this.orginPicWidth = this.picWidth;
      this.orignPicHeight = this.picHeight;
      if (this.listen) {
        addEvent(document.documentElement, eventsFor.move, this.handleResize);
        addEvent(document.documentElement, eventsFor.stop, this.handleUp);
      }
    },
    // 旋转柄触摸按下
    handleRotateTouchDown(handle, e) {
      eventsFor = events.touch;
      this.handleRotateDown(handle, e);
    },
    handleRotate90() {
      this.photoRotate = this.photoRotate + 90;
      if (this.photoRotate == 360) {
        setTimeout(() => {
          this.photoRotate = 0;
        }, 600);
      }
    },
    // 旋转柄按下
    handleRotateDown(handle, e) {
      if (e instanceof MouseEvent && e.which !== 1) {
        return;
      }

      if (this.onResizeStart(handle, e) === false) {
        return;
      }

      if (e.stopPropagation) e.stopPropagation();

      this.rotating = true;

      this.mouseClickPosition.mouseX = e.touches ? e.touches[0].pageX : e.pageX;
      this.mouseClickPosition.mouseY = e.touches ? e.touches[0].pageY : e.pageY;
      this.mouseClickPosition.left = this.left;
      this.mouseClickPosition.right = this.right;
      this.mouseClickPosition.top = this.top;
      this.mouseClickPosition.bottom = this.bottom;
      this.mouseClickPosition.w = this.width;
      this.mouseClickPosition.h = this.height;

      this.bounds = this.calcResizeLimits();
      if (this.listen) {
        addEvent(document.documentElement, eventsFor.stop, this.handleUp);
      }
    },
    handleMoveTouchDown(handle, e) {
      console.log('31231')
      eventsFor = events.touch;
      this.handleMoveDown(handle, e);
    },
    // 旋转柄按下
    handleMoveDown(handle, e) {
      if (e instanceof MouseEvent && e.which !== 1) {
        return;
      }

      if (this.onResizeStart(handle, e) === false) {
        return;
      }

      if (e.stopPropagation) e.stopPropagation();
      this.moving = true;
      this.moveState = true;
      this.mouseClickPosition.mouseX = e.touches ? e.touches[0].pageX : e.pageX;
      this.mouseClickPosition.mouseY = e.touches ? e.touches[0].pageY : e.pageY;
      this.mouseClickPosition.left = this.left;
      this.mouseClickPosition.right = this.right;
      this.mouseClickPosition.top = this.top;
      this.mouseClickPosition.bottom = this.bottom;
      this.mouseClickPosition.w = this.width;
      this.mouseClickPosition.h = this.height;

      this.bounds = this.calcResizeLimits();
      if (this.listen) {
        addEvent(document.documentElement, eventsFor.stop, this.handleUp);
      }
    },
    catePic() {
      this.moveState = true
    },
    cancelCatePic() {
      this.moveState = false 
    },
    // 计算调整大小范围
    calcResizeLimits() {
      let minW = this.minW;
      let minH = this.minH;
      let maxW = this.maxW;
      let maxH = this.maxH;

      const aspectFactor = this.aspectFactor;
      const [gridX, gridY] = this.grid;
      const width = this.width;
      const height = this.height;
      const left = this.left;
      const top = this.top;
      const right = this.right;
      const bottom = this.bottom;

      if (this.lockAspectRatio) {
        if (minW / minH > aspectFactor) {
          minH = minW / aspectFactor;
        } else {
          minW = aspectFactor * minH;
        }

        if (maxW && maxH) {
          maxW = Math.min(maxW, aspectFactor * maxH);
          maxH = Math.min(maxH, maxW / aspectFactor);
        } else if (maxW) {
          maxH = maxW / aspectFactor;
        } else if (maxH) {
          maxW = aspectFactor * maxH;
        }
      }

      maxW = maxW - (maxW % gridX);
      maxH = maxH - (maxH % gridY);

      const limits = {
        minLeft: null,
        maxLeft: null,
        minTop: null,
        maxTop: null,
        minRight: null,
        maxRight: null,
        minBottom: null,
        maxBottom: null,
      };

      if (this.parent) {
        limits.minLeft = left % gridX;
        limits.maxLeft = left + Math.floor((width - minW) / gridX) * gridX;
        limits.minTop = top % gridY;
        limits.maxTop = top + Math.floor((height - minH) / gridY) * gridY;
        limits.minRight = right % gridX;
        limits.maxRight = right + Math.floor((width - minW) / gridX) * gridX;
        limits.minBottom = bottom % gridY;
        limits.maxBottom = bottom + Math.floor((height - minH) / gridY) * gridY;

        if (maxW) {
          limits.minLeft = Math.max(
            limits.minLeft,
            this.parentWidth - right - maxW
          );
          limits.minRight = Math.max(
            limits.minRight,
            this.parentWidth - left - maxW
          );
        }

        if (maxH) {
          limits.minTop = Math.max(
            limits.minTop,
            this.parentHeight - bottom - maxH
          );
          limits.minBottom = Math.max(
            limits.minBottom,
            this.parentHeight - top - maxH
          );
        }

        if (this.lockAspectRatio) {
          limits.minLeft = Math.max(limits.minLeft, left - top * aspectFactor);
          limits.minTop = Math.max(limits.minTop, top - left / aspectFactor);
          limits.minRight = Math.max(
            limits.minRight,
            right - bottom * aspectFactor
          );
          limits.minBottom = Math.max(
            limits.minBottom,
            bottom - right / aspectFactor
          );
        }
      } else {
        limits.minLeft = null;
        limits.maxLeft = left + Math.floor((width - minW) / gridX) * gridX;
        limits.minTop = null;
        limits.maxTop = top + Math.floor((height - minH) / gridY) * gridY;
        limits.minRight = null;
        limits.maxRight = right + Math.floor((width - minW) / gridX) * gridX;
        limits.minBottom = null;
        limits.maxBottom = bottom + Math.floor((height - minH) / gridY) * gridY;

        if (maxW) {
          limits.minLeft = -(right + maxW);
          limits.minRight = -(left + maxW);
        }

        if (maxH) {
          limits.minTop = -(bottom + maxH);
          limits.minBottom = -(top + maxH);
        }

        if (this.lockAspectRatio && maxW && maxH) {
          limits.minLeft = Math.min(limits.minLeft, -(right + maxW));
          limits.minTop = Math.min(limits.minTop, -(maxH + bottom));
          limits.minRight = Math.min(limits.minRight, -left - maxW);
          limits.minBottom = Math.min(limits.minBottom, -top - maxH);
        }
      }

      return limits;
    },
    // 移动
    move(e) {
      if (this.moving) {
        this.handleMoving(e);
        return false;
      }
      if (this.locking) return false;
      if (this.rotating) {
        this.handleRotating(e);
        return false;
      }
      if (this.resizing) {
        this.handleResize(e);
      } else if (this.dragging) {
        this.handleDrag(e);
      }
    },
    // 元素移动
    async handleDrag(e) {
      const axis = this.axis;
      const grid = this.grid;
      const bounds = this.bounds;
      const mouseClickPosition = this.mouseClickPosition;

      const tmpDeltaX =
        axis && axis !== "y"
          ? mouseClickPosition.mouseX -
            (e.touches ? e.touches[0].pageX : e.pageX)
          : 0;
      const tmpDeltaY =
        axis && axis !== "x"
          ? mouseClickPosition.mouseY -
            (e.touches ? e.touches[0].pageY : e.pageY)
          : 0;

      const [deltaX, deltaY] = snapToGrid(
        grid,
        tmpDeltaX,
        tmpDeltaY,
        this.scaleRatio
      );

      const left = restrictToBounds(
        mouseClickPosition.left - deltaX,
        bounds.minLeft,
        bounds.maxLeft
      );
      const top = restrictToBounds(
        mouseClickPosition.top - deltaY,
        bounds.minTop,
        bounds.maxTop
      );
      if (this.onDrag(left, top) === false) {
        return;
      }
      const right = restrictToBounds(
        mouseClickPosition.right + deltaX,
        bounds.minRight,
        bounds.maxRight
      );
      const bottom = restrictToBounds(
        mouseClickPosition.bottom + deltaY,
        bounds.minBottom,
        bounds.maxBottom
      );
      this.left = isNaN(left) ? this.left : left;
      this.top = isNaN(top) ? this.top : top;
      this.right = isNaN(right) ? this.right : right;
      this.bottom = isNaN(bottom) ? this.bottom : bottom;

      await this.snapCheck();
      this.$emit("dragging", this.left, this.top, this.dIndex);
    },
    moveHorizontally(val) {
      const [deltaX, _] = snapToGrid(this.grid, val, this.top, this.scale);
      const left = restrictToBounds(
        deltaX,
        this.bounds.minLeft,
        this.bounds.maxLeft
      );
      this.left = left;
      this.right = this.parentWidth - this.width - left;
    },
    moveVertically(val) {
      const [_, deltaY] = snapToGrid(this.grid, this.left, val, this.scale);
      const top = restrictToBounds(
        deltaY,
        this.bounds.minTop,
        this.bounds.maxTop
      );
      this.top = top;
      this.bottom = this.parentHeight - this.height - top;
    },
    // 控制柄移动
    handleResize(e) {
      if (this.locking) return false;
      this.resizingState = true;
      let left = this.left;
      let top = this.top;
      let right = this.right;
      let bottom = this.bottom;
      let rotate = this.rotate;
      const mouseClickPosition = this.mouseClickPosition;
      const lockAspectRatio = this.lockAspectRatio;
      const aspectFactor = this.aspectFactor;
      const tmpDeltaX =
        mouseClickPosition.mouseX - (e.touches ? e.touches[0].pageX : e.pageX);
      const tmpDeltaY =
        mouseClickPosition.mouseY - (e.touches ? e.touches[0].pageY : e.pageY);
      if (!this.widthTouched && tmpDeltaX) {
        this.widthTouched = true;
      }
      if (!this.heightTouched && tmpDeltaY) {
        this.heightTouched = true;
      }
      const [deltaX, deltaY] = snapToGrid(
        this.grid,
        tmpDeltaX,
        tmpDeltaY,
        this.scaleRatio
      );

      if (this.handle.includes("b")) {
        bottom = restrictToBounds(
          mouseClickPosition.bottom + deltaY,
          this.bounds.minBottom,
          this.bounds.maxBottom
        );
        if (
          this.lockAspectRatio &&
          this.resizingOnY &&
          !this.handle.includes("l")
        ) {
          right = this.right - (this.bottom - bottom) * aspectFactor;
        }
      } else if (this.handle.includes("t")) {
        top = restrictToBounds(
          mouseClickPosition.top - deltaY,
          this.bounds.minTop,
          this.bounds.maxTop
        );
        if (this.lockAspectRatio && this.resizingOnY) {
          left = this.left - (this.top - top) * aspectFactor;
        }
      }

      if (this.handle.includes("r")) {
        right = restrictToBounds(
          mouseClickPosition.right + deltaX,
          this.bounds.minRight,
          this.bounds.maxRight
        );
        if (this.lockAspectRatio && this.resizingOnX) {
          bottom = this.bottom - (this.right - right) / aspectFactor;
        }
      } else if (this.handle.includes("l") && !this.handle.includes("b")) {
        left = restrictToBounds(
          mouseClickPosition.left - deltaX,
          this.bounds.minLeft,
          this.bounds.maxLeft
        );
        if (this.lockAspectRatio && this.resizingOnX) {
          top = this.top - (this.left - left) / aspectFactor;
        }
      }
      const width = computeWidth(this.parentWidth, left, right);
      const height = computeHeight(this.parentHeight, top, bottom);
      const oraginX = this.left + this.width / 2;
      const oraginY = this.top + this.height / 2;
      const touchX = mouseClickPosition.mouseX;
      const touchY = mouseClickPosition.mouseY;
      const resizeX = e.touches ? e.touches[0].pageX : e.pageX;
      const resizeY = e.touches ? e.touches[0].pageY : e.pageY;
      if (this.onResize(this.handle, left, top, width, height) === false) {
        return;
      }

      if (this.type == 1 || this.type == 2) {
        this.picLeft =
          this.photoLeft +
          ((width - this.orginWidth) / this.orginWidth) * this.photoLeft;
        this.picTop =
          this.photoTop - (tmpDeltaY / this.orginHeight) * this.photoTop;
      }

      this.left = left;
      this.top = top;
      this.right = right;
      this.bottom = bottom;
      this.width = width;
      if (this.type == 5) {
        this.height = window
          .getComputedStyle(this.$refs.textarea)
          .height.replace("px", "");
      } else {
        this.height = this.type == 8 ? 1 : height;
      }
      
      if (this.type == 5 && this.width < this.fontSize + 1) {
        this.width = this.fontSize + 1;
      }
      // this.orginWidth = this.width
      // this.orginHeight = this.height
      if (this.type == 1) {
        this.resizingCalcPicScale();
      }

      if (this.type == 9) {
        if (this.lockAspectRatio) {
          const p = 1 + (width - this.orginWidth) / this.orginWidth;
          this.picLeft = this.orginPicLeft * p;
          this.picTop = this.orginPicTop * p;
          // this.picWidth = this.orginPicWidth * (p + 1)
          // this.picHeight = this.orignPicHeight * (p + 1)
          this.borderRadius = Number(this.orginBorderRadius) * p
          this.reinitPhoto();
          this.checkRange2();
          this.$emit(
            "resizing",
            this.left,
            this.top,
            this.width,
            this.height,
            this.picLeft,
            this.picTop,
            this.dragIndex,
            this.borderRadius
          );
        } else {
          this.$emit(
            "resizing",
            this.left,
            this.top,
            this.width,
            this.height,
            this.picLeft,
            this.picTop,
            this.dragIndex,
            this.width / this.orginWidth
          );
          this.reinitPhoto();
        }
        return false;
      }

      if (this.type == 2) {
        const p = 1 + (width - this.orginWidth) / this.orginWidth;
        this.picLeft = this.orginPicLeft * p;
        this.picTop = this.orginPicTop * p;
        // this.checkRange();
        // this.picLeft =
        //   this.photoLeft -
        //   ((width - this.orginWidth) / this.orginWidth) * this.photoLeft;
        // this.picTop =
        //   this.photoTop -
        //   ((width - this.orginWidth) / this.orginWidth) * this.photoTop;

        // this.picTop = this.photoLeft - ((width-this.orginWidth) / this.orginWidth) * this.photoLeft;
        this.resizeCanvas();
        this.$emit(
          "resizing",
          this.left,
          this.top,
          this.width,
          this.height,
          this.picLeft,
          this.picTop,
          this.dragIndex
        );
      } else {
        if (this.photoMsg && this.photoMsg.width) {
          this.originPhotoLeft = -(
            ((1 - this.photoMsg.width / this.photoMsg.height) *
              this.picScale *
              this.width) /
            2
          );
          this.originPhotoTop =
            ((1 - this.photoMsg.width / this.photoMsg.height) *
              this.picScale *
              this.width) /
            2;
        }
        // this.calcPicScale2()
        this.$emit(
          "resizing",
          this.left,
          this.top,
          this.width,
          this.height,
          this.picLeft,
          this.picTop,
          this.dragIndex,
          this.width / this.orginWidth
        );
      }
    },
    //移动照片
    handleMoving(e) {
      console.log('move')
      if ((this.type == 1 || this.type == 9) && this.backgroundImg == "")
        return false;
      if (this.type == 2 && this.showPhoto == "") return false;
      let left = this.left;
      let top = this.top;
      let right = this.right;
      let bottom = this.bottom;
      let rotate = this.rotate;
      const mouseClickPosition = this.mouseClickPosition;
      const lockAspectRatio = this.lockAspectRatio;
      const aspectFactor = this.aspectFactor;

      const tmpDeltaX =
        mouseClickPosition.mouseX - (e.touches ? e.touches[0].pageX : e.pageX);
      const tmpDeltaY =
        mouseClickPosition.mouseY - (e.touches ? e.touches[0].pageY : e.pageY);

      if (!this.widthTouched && tmpDeltaX) {
        this.widthTouched = true;
      }
      if (!this.heightTouched && tmpDeltaY) {
        this.heightTouched = true;
      }

      const width = computeWidth(this.parentWidth, left, right);
      const height = computeHeight(this.parentHeight, top, bottom);
      if (this.onResize(this.handle, left, top, width, height) === false) {
        return;
      }
      if (this.type == 9) {
        const { maxX, maxY, minX, minY } = this.checkRange2();
        const moveX = this.orignPicLeft - tmpDeltaX / 1.6;
        const moveY = this.orignPicTop - tmpDeltaY / 1.6;
        if (moveX < maxX && moveX > minX) {
          this.picLeft = moveX;
        } else if (moveX > maxX) {
          this.picLeft = maxX;
        } else if (moveX <= minX) {
          this.picLeft = minX;
        }
        if (moveY < maxY && moveY > minY) {
          this.picTop = moveY;
        } else if (moveY >= maxY) {
          this.picTop = maxY;
        } else if (moveY <= minY) {
          this.picTop = minY;
        }
        return false;
      }
      if (this.type == 1) {
        this.transpantPx = [0, 0, 0, 0];
      }
      const maxX = 0 + this.transpantPx[0];
      const maxY = 0 + this.transpantPx[1];
      let minX = 0;
      let minY = 0;
      let picRotate = this.picRotate % 360;
      switch (picRotate) {
        case 0:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 90:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[3];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          break;
        case 180:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.photoMsg.height *
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale)) /
              this.photoMsg.width -
            this.transpantPx[3];
          break;
        case 270:
          minX =
            this.width -
            this.borderLeft -
            this.borderRight -
            (this.photoMsg.width / this.photoMsg.height) *
              (this.width - this.borderLeft - this.borderRight) *
              this.picScale -
            this.transpantPx[2];
          minY =
            this.height -
            this.borderTop -
            this.borderBottom -
            (this.width - this.borderLeft - this.borderRight) * this.picScale -
            this.transpantPx[3];
          break;
        default:
          break;
      }

      const moveX = this.orignPicLeft - tmpDeltaX / 1.6;
      const moveY = this.orignPicTop - tmpDeltaY / 1.6;
      if (moveX < maxX && moveX > minX) {
        this.picLeft = moveX;
      } else if (moveX > maxX) {
        this.picLeft = maxX;
      } else if (moveX <= minX) {
        this.picLeft = minX;
      }
      if (moveY < maxY && moveY > minY) {
        this.picTop = moveY;
      } else if (moveY >= maxY) {
        this.picTop = maxY;
      } else if (moveY <= minY) {
        this.picTop = minY;
      }

      // this.$emit('dragMoving',this.dragIndex)
    },
    handleRotating(e) {
      let left = this.left;
      let top = this.top;
      let right = this.right;
      let bottom = this.bottom;
      let rotate = this.rotate;
      const mouseClickPosition = this.mouseClickPosition;
      const lockAspectRatio = this.lockAspectRatio;
      const aspectFactor = this.aspectFactor;

      const tmpDeltaX =
        mouseClickPosition.mouseX - (e.touches ? e.touches[0].pageX : e.pageX);
      const tmpDeltaY =
        mouseClickPosition.mouseY - (e.touches ? e.touches[0].pageY : e.pageY);

      if (!this.widthTouched && tmpDeltaX) {
        this.widthTouched = true;
      }
      if (!this.heightTouched && tmpDeltaY) {
        this.heightTouched = true;
      }
      const [deltaX, deltaY] = snapToGrid(
        this.grid,
        tmpDeltaX,
        tmpDeltaY,
        this.scaleRatio
      );

      const width = computeWidth(this.parentWidth, left, right);
      const height = computeHeight(this.parentHeight, top, bottom);
      const oraginX =
        this.$refs.drag.getBoundingClientRect().left +
        this.$refs.drag.getBoundingClientRect().width / 2;
      const oraginY =
        this.$refs.drag.getBoundingClientRect().top +
        this.$refs.drag.getBoundingClientRect().height / 2;
      const touchX = mouseClickPosition.mouseX;
      const touchY = mouseClickPosition.mouseY;
      const resizeX = e.touches ? e.touches[0].pageX : e.pageX;
      const resizeY = e.touches ? e.touches[0].pageY : e.pageY;
      rotate = computeRotate(
        { oraginX, oraginY },
        { touchX, touchY },
        { resizeX, resizeY },
        this.originR
      );
      if (this.onResize(this.handle, left, top, width, height) === false) {
        return;
      }
      this.rotate = rotate;
      this.$emit(
        "rotating",
        this.left,
        this.top,
        this.width,
        this.height,
        this.rotate,
        this.dragIndex
      );
    },
    textChange(e) {
      this.editState = false;
      this.dragging = true;
      // this.matchText()
      if (!e.target.value) {
        this.content = this.text;
      }
      this.$nextTick(() => {
        this.height = window
          .getComputedStyle(this.$refs.textarea)
          .height.replace("px", "");
        this.$emit(
          "changeContent",
          e.target.value ? e.target.value : this.text,
          this.height,
          "",
          this.dragIndex
        );
      });
    },
    rotatePhoto() {
      if (this.moveState2) return false;
      // this.picRotate = (this.picRotate + 90) % 360;
      this.picRotate = this.picRotate + 90;
    },
    changeWidth(val) {
      const [newWidth, _] = snapToGrid(this.grid, val, 0, this.scale);
      let right = restrictToBounds(
        this.parentWidth - newWidth - this.left,
        this.bounds.minRight,
        this.bounds.maxRight
      );
      let bottom = this.bottom;
      if (this.lockAspectRatio) {
        bottom = this.bottom - (this.right - right) / this.aspectFactor;
      }
      const width = computeWidth(this.parentWidth, this.left, right);
      const height = computeHeight(this.parentHeight, this.top, bottom);
      this.right = right;
      this.bottom = bottom;
      this.width = width;
      this.height = height;
    },
    changeHeight(val) {
      const [_, newHeight] = snapToGrid(this.grid, 0, val, this.scale);
      let bottom = restrictToBounds(
        this.parentHeight - newHeight - this.top,
        this.bounds.minBottom,
        this.bounds.maxBottom
      );
      let right = this.right;
      if (this.lockAspectRatio) {
        right = this.right - (this.bottom - bottom) * this.aspectFactor;
      }
      const width = computeWidth(this.parentWidth, this.left, right);
      const height = computeHeight(this.parentHeight, this.top, bottom);
      this.right = right;
      this.bottom = bottom;
      this.width = width;
      this.height = height;
    },
    isMobile() {
            let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            return flag;
        },
    // 从控制柄松开
    async handleUp(e) {
      this.handle = null;
      const isMobile = this.isMobile()
      if (!isMobile) {
        this.moveState = false
      }
      // 初始化辅助线数据
      const temArr = new Array(3).fill({
        display: false,
        position: "",
        origin: "",
        lineLength: "",
      });
      const refLine = { vLine: [], hLine: [] };
      for (let i in refLine) {
        refLine[i] = JSON.parse(JSON.stringify(temArr));
      }

      if (this.resizing) {
        this.resizing = false;
        await this.conflictCheck();

        this.$emit("refLineParams", refLine);
        setTimeout(() => {
          if (this.type == 2) {
            this.resizeCanvas();
            var mask = new Image();
            mask.setAttribute("crossOrigin", "Anonymous");
            mask.src = this.backimg2;
            mask.onload = () => {
              this.getImageBoundRect(mask);
            };
          }
        }, 20);
        this.$emit(
          "resizestop",
          this.left,
          this.top,
          this.width,
          this.height,
          this.picLeft,
          this.picTop,
          this.dragIndex,
          this.borderRadius,
          this.width / this.orginWidth
        );
        this.resizingState = false;
      }
      if (this.dragging) {
        this.dragging = false;
        await this.conflictCheck();
        this.$emit("refLineParams", refLine);
        if (this.left != this.x || this.y != this.top) {
          this.$emit("dragstop", this.left, this.top, this.dragIndex);
        }
      }
      if (this.rotating) {
        this.rotating = false;
        await this.conflictCheck();
        this.$emit("refLineParams", refLine);
        this.$emit(
          "rotatingStop",
          this.left,
          this.top,
          this.width,
          this.height,
          this.rotate,
          this.dragIndex
        );
      }
      if (this.moving) {
        this.moving = false;
        if (this.type != 9 && this.type != 2) {
          this.moveState = false;
        }
        await this.conflictCheck();
        this.$emit("refLineParams", refLine);
        if (this.type == 2) {
          this.resizeCanvas();
        }
        if ((this.type == 1 || this.type == 9) && this.backgroundImg == "") {
          return false;
        }
        if (this.type == 2 && this.showPhoto == "") {
          return false;
        }
        this.$emit(
          "movingStop",
          this.picLeft,
          this.picTop,
          this.picScale,
          this.dragIndex
        );
        this.orignPicLeft = this.picLeft;
        this.orignPicTop = this.picTop;
      }
      this.resetBoundsAndMouseState();
      removeEvent(document.documentElement, eventsFor.move, this.handleResize);
    },
    // 新增方法 ↓↓↓
    // 设置属性
    settingAttribute() {
      // 设置冲突检测
      this.$el.setAttribute("data-is-check", `${this.isConflictCheck}`);
      // 设置对齐元素
      this.$el.setAttribute("data-is-snap", `${this.snap}`);
    },
    // 冲突检测
    conflictCheck() {
      const top = this.top;
      const left = this.left;
      const width = this.width;
      const height = this.height;

      if (this.isConflictCheck) {
        const nodes = this.$el.parentNode.childNodes; // 获取当前父节点下所有子节点
        for (let item of nodes) {
          if (
            item.className !== undefined &&
            !item.className.includes(this.classNameActive) &&
            item.getAttribute("data-is-check") !== null &&
            item.getAttribute("data-is-check") !== "false"
          ) {
            const tw = item.offsetWidth;
            const th = item.offsetHeight;
            // 正则获取left与right
            let [tl, tt] = this.formatTransformVal(item.style.transform);

            // 左上角与右下角重叠
            const tfAndBr =
              (top >= tt && left >= tl && tt + th > top && tl + tw > left) ||
              (top <= tt &&
                left < tl &&
                top + height > tt &&
                left + width > tl);
            // 右上角与左下角重叠
            const brAndTf =
              (left <= tl && top >= tt && left + width > tl && top < tt + th) ||
              (top < tt && left > tl && top + height > tt && left < tl + tw);
            // 下边与上边重叠
            const bAndT =
              (top <= tt &&
                left >= tl &&
                top + height > tt &&
                left < tl + tw) ||
              (top >= tt && left <= tl && top < tt + th && left > tl + tw);
            // 上边与下边重叠（宽度不一样）
            const tAndB =
              (top <= tt &&
                left >= tl &&
                top + height > tt &&
                left < tl + tw) ||
              (top >= tt && left <= tl && top < tt + th && left > tl + tw);
            // 左边与右边重叠
            const lAndR =
              (left >= tl && top >= tt && left < tl + tw && top < tt + th) ||
              (top > tt && left <= tl && left + width > tl && top < tt + th);
            // 左边与右边重叠（高度不一样）
            const rAndL =
              (top <= tt &&
                left >= tl &&
                top + height > tt &&
                left < tl + tw) ||
              (top >= tt && left <= tl && top < tt + th && left + width > tl);

            // 如果冲突，就将回退到移动前的位置
            if (tfAndBr || brAndTf || bAndT || tAndB || lAndR || rAndL) {
              this.top = this.mouseClickPosition.top;
              this.left = this.mouseClickPosition.left;
              this.right = this.mouseClickPosition.right;
              this.bottom = this.mouseClickPosition.bottom;
              this.width = this.mouseClickPosition.w;
              this.height = this.mouseClickPosition.h;
            }
          }
        }
      }
    },
    // 检测对齐元素
    async snapCheck() {
      let width = this.width;
      let height = this.height;
      if (this.snap) {
        let activeLeft = this.left;
        let activeRight = this.left + width;
        let activeTop = this.top;
        let activeBottom = this.top + height;

        // 初始化辅助线数据
        const temArr = new Array(3).fill({
          display: false,
          position: "",
          origin: "",
          lineLength: "",
        });
        const refLine = { vLine: [], hLine: [] };
        for (let i in refLine) {
          refLine[i] = JSON.parse(JSON.stringify(temArr));
        }

        // 获取当前父节点下所有子节点
        const nodes = this.$el.parentNode.childNodes;

        let tem = {
          value: { x: [[], [], []], y: [[], [], []] },
          display: [],
          position: [],
        };
        const {
          groupWidth,
          groupHeight,
          groupLeft,
          groupTop,
          bln,
        } = await this.getActiveAll(nodes);
        if (!bln) {
          width = groupWidth;
          height = groupHeight;
          activeLeft = groupLeft;
          activeRight = groupLeft + groupWidth;
          activeTop = groupTop;
          activeBottom = groupTop + groupHeight;
        }
        for (let item of nodes) {
          if (
            item.className !== undefined &&
            !item.className.includes(this.classNameActive) &&
            item.getAttribute("data-is-snap") !== null &&
            item.getAttribute("data-is-snap") !== "false"
          ) {
            const w = item.offsetWidth;
            const h = item.offsetHeight;
            const [l, t] = this.formatTransformVal(item.style.transform);
            const r = l + w; // 对齐目标right
            const b = t + h; // 对齐目标的bottom

            const hc =
              Math.abs(activeTop + height / 2 - (t + h / 2)) <=
              this.snapTolerance; // 水平中线
            const vc =
              Math.abs(activeLeft + width / 2 - (l + w / 2)) <=
              this.snapTolerance; // 垂直中线

            const ts = Math.abs(t - activeBottom) <= this.snapTolerance; // 从上到下
            const TS = Math.abs(b - activeBottom) <= this.snapTolerance; // 从上到下
            const bs = Math.abs(t - activeTop) <= this.snapTolerance; // 从下到上
            const BS = Math.abs(b - activeTop) <= this.snapTolerance; // 从下到上

            const ls = Math.abs(l - activeRight) <= this.snapTolerance; // 外左
            const LS = Math.abs(r - activeRight) <= this.snapTolerance; // 外左
            const rs = Math.abs(l - activeLeft) <= this.snapTolerance; // 外右
            const RS = Math.abs(r - activeLeft) <= this.snapTolerance; // 外右

            tem["display"] = [ts, TS, bs, BS, hc, hc, ls, LS, rs, RS, vc, vc];
            tem["position"] = [
              t,
              b,
              t,
              b,
              t + h / 2,
              t + h / 2,
              l,
              r,
              l,
              r,
              l + w / 2,
              l + w / 2,
            ];

            if (ts) {
              if (bln) {
                this.top = t - height;
                this.bottom = this.parentHeight - this.top - height;
              }
              tem.value.y[0].push(l, r, activeLeft, activeRight);
            }
            if (bs) {
              if (bln) {
                this.top = t;
                this.bottom = this.parentHeight - this.top - height;
              }
              tem.value.y[0].push(l, r, activeLeft, activeRight);
            }
            if (TS) {
              if (bln) {
                this.top = b - height;
                this.bottom = this.parentHeight - this.top - height;
              }
              tem.value.y[1].push(l, r, activeLeft, activeRight);
            }
            if (BS) {
              if (bln) {
                this.top = b;
                this.bottom = this.parentHeight - this.top - height;
              }
              tem.value.y[1].push(l, r, activeLeft, activeRight);
            }

            if (ls) {
              if (bln) {
                this.left = l - width;
                this.right = this.parentWidth - this.left - width;
              }
              tem.value.x[0].push(t, b, activeTop, activeBottom);
            }
            if (rs) {
              if (bln) {
                this.left = l;
                this.right = this.parentWidth - this.left - width;
              }
              tem.value.x[0].push(t, b, activeTop, activeBottom);
            }
            if (LS) {
              if (bln) {
                this.left = r - width;
                this.right = this.parentWidth - this.left - width;
              }
              tem.value.x[1].push(t, b, activeTop, activeBottom);
            }
            if (RS) {
              if (bln) {
                this.left = r;
                this.right = this.parentWidth - this.left - width;
              }
              tem.value.x[1].push(t, b, activeTop, activeBottom);
            }

            if (hc) {
              if (bln) {
                this.top = t + h / 2 - height / 2;
                this.bottom = this.parentHeight - this.top - height;
              }
              tem.value.y[2].push(l, r, activeLeft, activeRight);
            }
            if (vc) {
              if (bln) {
                this.left = l + w / 2 - width / 2;
                this.right = this.parentWidth - this.left - width;
              }
              tem.value.x[2].push(t, b, activeTop, activeBottom);
            }
            // 辅助线坐标与是否显示(display)对应的数组,易于循环遍历
            const arrTem = [0, 1, 0, 1, 2, 2, 0, 1, 0, 1, 2, 2];
            for (let i = 0; i <= arrTem.length; i++) {
              // 前6为Y辅助线,后6为X辅助线
              const xory = i < 6 ? "y" : "x";
              const horv = i < 6 ? "hLine" : "vLine";
              if (tem.display[i]) {
                const { origin, length } = this.calcLineValues(
                  tem.value[xory][arrTem[i]]
                );
                refLine[horv][arrTem[i]].display = tem.display[i];
                refLine[horv][arrTem[i]].position = tem.position[i] + "px";
                refLine[horv][arrTem[i]].origin = origin;
                refLine[horv][arrTem[i]].lineLength = length;
              }
            }
          }
        }
        this.$emit("refLineParams", refLine);
      }
    },
    calcLineValues(arr) {
      const length = Math.max(...arr) - Math.min(...arr) + "px";
      const origin = Math.min(...arr) + "px";
      return { length, origin };
    },
    async getActiveAll(nodes) {
      const activeAll = [];
      const XArray = [];
      const YArray = [];
      let groupWidth = 0;
      let groupHeight = 0;
      let groupLeft = 0;
      let groupTop = 0;
      for (let item of nodes) {
        if (
          item.className !== undefined &&
          item.className.includes(this.classNameActive)
        ) {
          activeAll.push(item);
        }
      }
      const AllLength = activeAll.length;
      if (AllLength > 1) {
        for (let i of activeAll) {
          const l = i.offsetLeft;
          const r = l + i.offsetWidth;
          const t = i.offsetTop;
          const b = t + i.offsetHeight;
          XArray.push(t, b);
          YArray.push(l, r);
        }
        groupWidth = Math.max(...YArray) - Math.min(...YArray);
        groupHeight = Math.max(...XArray) - Math.min(...XArray);
        groupLeft = Math.min(...YArray);
        groupTop = Math.min(...XArray);
      }
      const bln = AllLength === 1;
      return { groupWidth, groupHeight, groupLeft, groupTop, bln };
    },
    // 正则获取left与top
    formatTransformVal(string) {
      let [left, top] = string.replace(/[^0-9\-,]/g, "").split(",");
      if (top === undefined) top = 0;
      return [+left, +top];
    },
  },
  computed: {
    pw() {
      return  Math.floor(
            (this.picScale + 0.009) *
              (this.width - this.borderLeft - this.borderRight)
          )
    },
    lineStyle() {
      return (n) => {
        // console.log(n)
      };
    },
    handleStyle() {
      return (stick) => {
        if (!this.handleInfo.switch)
          return { display: this.enabled ? "block" : "none" };

        const size = (this.handleInfo.size / this.scaleRatio).toFixed(4);
        const offset = (this.handleInfo.offset / this.scaleRatio).toFixed(4);
        const center = (size / 2).toFixed(2);

        const styleMap = {
          tl: {
            top: `${offset - this.bTop}px`,
            left: `${offset - this.bLeft}px`,
          },
          tm: {
            top: `${offset - this.bTop}px`,
            left: `calc(50% - ${center + this.bLeft}px)`,
          },
          tr: {
            top: `${offset - this.bTop}px`,
            right: `${offset - this.bRight}px`,
          },
          mr: {
            top: `calc(50% - ${center - this.bTop}px)`,
            right: `${offset - this.bRight}px`,
          },
          br: {
            bottom: `${offset - this.bBottom}px`,
            right: `${offset - this.bRight}px`,
          },
          bm: {
            bottom: `${offset - this.bBottom}px`,
            right: `calc(50% - ${center - this.bRight}px)`,
          },
          bl: {
            bottom: `${offset - this.bBottom}px`,
            left: `${offset - this.bLeft}px`,
          },
          ml: {
            top: `calc(50% - ${center - this.bTop}px)`,
            left: `${offset - this.bLeft}px`,
          },
        };
        const stickStyle = {
          width: `${size}px`,
          height: `${size}px`,
          top: styleMap[stick].top,
          left: styleMap[stick].left,
          right: styleMap[stick].right,
          bottom: styleMap[stick].bottom,
        };
        stickStyle.display = this.enabled ? "block" : "none";
        return stickStyle;
      };
    },
    moveboxStyle() {
      return {
        right: this.moveboxLeft + this.borderRight + "px",
        top: this.moveboxTop + "px",
      };
    },
    style() {
      return {
        // transform: `translate(${this.left}px, ${this.top}px) rotate(${this.rotate}deg)`,
        webkitTransform: `translate(${this.left}px, ${this.top}px) rotate(${this.rotate}deg)`,
        // transformOrigin: `${this.computedWidth/2}px ${this.computedHeight/2}px`,
        webkitTransformOrigin: `translate(${this.left}px, ${this.top}px)`,
        width: this.computedWidth,
        height: this.computedHeight,
        zIndex: this.type == 5 ? 100 + this.z : this.z,
        borderLeftWidth: this.type == 2 ? '0px' : this.bLeft + "px",
        borderRightWidth: this.type == 2 ? '0px' : this.bRight + "px",
        borderTopWidth: this.type == 2 ? '0px' : this.bTop + "px",
        borderBottomWidth: this.type == 2 ? '0px' : this.bBottom + "px",
        // boxShadow: this.shadow ? "0 0 4px 4px rgba(0,0,0,.08)" : "",
        borderRadius: this.borderRadius + "px",
        borderColor:
          this.bordersColor == null ? "transparent" : this.bordersColor,
        borderStyle: this.bStyle,
        position: "absolute",
        backgroundColor: this.type == 2 ? "transparent" : this.bColor,
        backgroundImage: this.backgroundImg,
        backgroundSize: "cover",
        opacity: this.opacity / 100,
        ...(this.dragging && this.disableUserSelect
          ? userSelectNone
          : userSelectAuto),
      };
    },
    moveStyle() {
      return {
        left: this.moveLeft + "px",
        top: this.moveTop + "px",
      };
    },
    photoStyle() {
      return {
        position: "absolute",
        left: 0 + "px",
        top: 0 + "px",
        width: 100 * this.picScale + "%",
        opacity: 0.7,
        transform: `rotate(${this.picRotate}deg) translate(${this.picLeft}px,${this.picTop}px)`,
      };
    },
    type2Style() {
      return {
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#cdcdcd",
        backgroundImage: "url(" + this.showPhoto + ")",
        backgroundSize: `${100 * this.picScale + "%"} auto`,
        backgroundPosition: `${this.picLeft + "px"} ${this.picTop + "px"}`,
        backgroundRepeat: "no-repeat",
        maskImage: "url(" + this.backimg2 + ")",
        maskRepeat: "no-repeat",
        maskSize: "100% 100%",
        transition: this.moveState2
          ? "backgroundSize 0.4s ease-in-out"
          : "none",
      };
    },
    style3() {
      return {
        fontFamily: this.fontFamily,
        fontWeight: this.fWeight,
        writingMode: this.writingMode,
        webkitWritingMode: this.writingMode,
        fontStyle: this.fontStyle,
        textDecoration: this.textDecoration,
        lineHeight: this.lHeight < 5 ? this.lineHeight : this.lHeight + "px",
        textAlign: this.tAlign,
        color: this.fColor,
        textIndent: this.textIndent + "em",
        outline: "none",
        fontSize: this.fSize != 0 ? this.fSize + "px" : "",
        textShadow: this.textShadow ? `0 1px 4px #101010` : "none",
        overflow: this.type == 5 ? 'hidden':'auto',
        ...(this.dragging && this.disableUserSelect
          ? userSelectNone
          : userSelectAuto),
      };
    },
    imgStyle() {
      return {
        width: "100%",
        height: this.type == 1 || this.type == 9 ? "100%" : "auto",
        ...(this.dragging && this.disableUserSelect
          ? userSelectNone
          : userSelectAuto),
      };
    },
    imgStyle12() {
      return {
        left:
          this.picRotate % 360 == 90 || this.picRotate % 360 == 270
            ? this.originPhotoLeft + "px"
            : 0,
        top:
          this.picRotate % 360 == 90 || this.picRotate % 360 == 270
            ? this.originPhotoTop + "px"
            : 0,
        width:
          Math.floor(
            (this.picScale + 0.009) *
              (this.width - this.borderLeft - this.borderRight)
          ) + "px",
        height: "auto",
        transform: `translate(${this.picLeft}px,${this.picTop}px) rotate(${this.picRotate}deg)`,
      };
    },
    imgStyle2() {
      return {
        left:
          this.picRotate % 360 == 90 || this.picRotate % 360 == 270
            ? this.originPhotoLeft + "px"
            : 0,
        top:
          this.picRotate % 360 == 90 || this.picRotate % 360 == 270
            ? this.originPhotoTop + "px"
            : 0,
        width:
          Math.floor( 
            1  *
              (this.width - this.borderLeft - this.borderRight)
          ) + "px",
        height: "auto",
        transform: `translate(${this.picLeft}px,${this.picTop}px) rotate(${this.picRotate}deg)`,
      };
    },
    imgStyle3() {
      return {
        left: this.originPhotoLeft + "px",
        top: this.originPhotoTop + "px",
        width: this.picWidth + "px",
        height: this.picHeight + "px",
        transform: `translate(${this.picLeft}px,${this.picTop}px) scale(${this.picScale}) rotate(${this.picRotate}deg)`,
      };
    },
    // 控制柄显示与否
    actualHandles() {
      if (!this.resizable) return [];

      return this.handles;
    },
    computedWidth() {
      if (this.w === "auto") {
        if (!this.widthTouched) {
          return "auto";
        }
      }
      return this.width + "px";
    },
    computedHeight() {
      if (this.type == 2) {
        return "auto";
      }
      if (this.h === "auto") {
        if (!this.heightTouched) {
          return "auto";
        }
      }
      return this.height + "px";
    },
    resizingOnX() {
      return (
        Boolean(this.handle) &&
        (this.handle.includes("l") || this.handle.includes("r"))
      );
    },
    resizingOnY() {
      return (
        Boolean(this.handle) &&
        (this.handle.includes("t") || this.handle.includes("b"))
      );
    },
    isCornerHandle() {
      return (
        Boolean(this.handle) && ["tl", "tr", "br", "bl"].includes(this.handle)
      );
    },
  },

  watch: {
    stepState(val) {
      this.isStep = val 
    },
    dIndex(val) {
      this.dragIndex = val
    },
    photoScale(val) {
      if (val) {
        this.picScale = val;
      } else {
        this.picScale =1
      }
    },
    // picLeft() {
    //   if (this.picLeft < this.range.minX) {
    //     this.picLeft = minX
    //   } else if (this.picLeft > this.range.maxX) {
    //     this.picLeft = maxX
    //   }
    // },
    // picTop(val) {
    //   console.log('picTop'+val)
    // },

    picRotate() {
      this.moveState2 = true;
      setTimeout(() => {
        this.moveState2 = false;
      }, 600);
      this.$nextTick(() => {
        if (this.type == 1) {
          this.picTop = 0;
          this.picLeft = 0;
          this.originPhotoTop = (
            ((this.width - this.borderLeft - this.borderRight) * this.picScale -
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale *
                this.photoMsg.height) /
                this.photoMsg.width) /
            2
          ).toFixed(4);
          this.originPhotoLeft = (
            -(
              (this.width - this.borderLeft - this.borderRight) *
                this.picScale -
              ((this.width - this.borderLeft - this.borderRight) *
                this.picScale *
                this.photoMsg.height) /
                this.photoMsg.width
            ) / 2
          ).toFixed(4);
          this.resizePicScale();
        } else if (this.type == 9) {
          this.initPhotoNew(true);
        }
        // } else if (this.type == 2) {
        //   console.log('checkrotate')
        //   this.resizeCanvas(true);
        // }
      });
    },
    
    fontFamily() {
      this.fFamily = this.fontFamily;
      // this.matchText()
      this.$emit("changeDrag", this.dragIndex);
    },
    levelType(val) {
      this.$emit(
        "changeLevelData",
        this.levelType,
        this.levelNum,
        this.level,
        this.fSize,
        this.dragIndex,
        this.height
      );
    },
    levelNum(val) {
      this.$emit(
        "changeLevelData",
        this.levelType,
        this.levelNum,
        this.level,
        this.fSize,
        this.dragIndex,
        this.height
      );
    },
    fSize(val) {
      if (this.type == 5) {
        this.$nextTick(() => {
          this.height = window
            .getComputedStyle(this.$refs.textarea)
            .height.replace("px", "");
        });
      }
      this.$emit(
        "changeLevelData",
        this.levelType,
        this.levelNum,
        this.level,
        this.fSize,
        this.dragIndex,
        this.height
      );
    },
    photoLeft(val) {
      this.picLeft = val;
    },
    photoTop(val) {
      if (val || val == 0) {
        this.picTop = val;
      } else {
        this.picTop = 0
      }
    },

    enNativeDrag(val) {
      this.enableNativeDrag = val;
    },
    content(val) {},
    lineHeight(val) {
      this.lHeight = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    textIndent(val) {
      this.$emit("changeDrag", this.dragIndex);
    },
    textAlign(val) {
      this.tAlign = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    fontWeight(val) {
      this.fWeight = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    textDecoration(val) {
      this.tDecoration = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    fontStyle(val) {
      this.fStyle = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    bRadius(val) {
      this.borderRadius = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    type(val) {

    },
    bImg2(val) {
      this.backimg2 = val;
      // console.log('类型',this.type)
      
      // this.backimg2 = val;
      // this.backimg2ChangeState = true
      // this.bLeft = 0 
      // this.bRight = 0 
      // this.bTop = 0
      // this.bBottom = 0

      // setTimeout(() => {
      //   this.resizeCanvas(true)
      //   if (!this.showPhoto) {
      //     this.$emit("changeDrag", this.dragIndex);
      //   }
      // }, 40);
      // setTimeout(() => {
      //   this.backimg2ChangeState = false
      //   this.changeState = false
      // }, 300);
      // this.$emit("changeDrag", this.dragIndex);
    },
    showPhoto(val) {
      console.log(val) 
      if (this.type != 2) return
      if (val == "") {
        this.$emit("changeDrag", this.dragIndex);
        return false
      }
      this.resizeCanvas(true);
      this.changeState = false;
    },
    paddingLeft(val) {
      this.pLeft = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    textShadow(val) {
      this.$emit("changeDrag", this.dragIndex);
    },
    shadow() {
      this.$emit("changeDrag", this.dragIndex);
    },
    paddingTop(val) {
      this.pTop = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    paddingRight(val) {
      this.pRight = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    paddingBottom(val) {
      this.pBottom = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    backColor(val) {
      this.bColor = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    backImg(val) {
      if (this.type != 1 && this.type != 9) {
        this.backgroundImg = val;
        return
      }
      if (val == "" && !this.text) {
        this.bColor = "#cccccc";
        this.backgroundImg = val;
        this.changeState = false;
        this.$emit("changeDrag", this.dragIndex);
      } else {
        this.backgroundImg = val;
        this.changeState = false;
        if (this.type == 1) {
          this.minScale = 1;
          this.picRotate = 0;
          this.picLeft = 0;
          this.picTop = 0;
          this.resizePicScale();
          this.$forceUpdate();
        } else if (this.type == 9) {
          this.moveState2 = false;
          this.minScale = 1;
          this.picRotate = 0;
          this.picLeft = 0;
          this.picTop = 0;
          this.initPhotoNew(true);
        } else {
          // var mask = new Image();
          //   mask.setAttribute("crossOrigin", "Anonymous");
          //   mask.src = this.backImg2;
          //   mask.onload = () => {
          //     this.getImageBoundRect(mask).then((res) => {
          //       this.resizeCanvas(true);
          //     });
          //   };
        }
      }
      this.$forceUpdate();
    },

    l(lock) {
      this.locking = lock;
      // this.$emit("changeDrag", this.dragIndex);
    },
    rotate(val) {
      this.changeState = true;
    },
    r(val) {
      this.rotate = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    dIndex(val) {
      this.dragIndex = val;
      // this.$emit("changeDrag", this.dragIndex);
    },
    o(val) {
      this.opacity = parseInt(val);
      this.$emit("changeDrag", this.dragIndex);
    },
    fontColor(val) {
      this.fColor = val;
      // this.matchText()
      this.$emit("changeDrag", this.dragIndex);
    },
    text(val, oldVal) {
      
      let arr = [];
      if (val) {
        val.split("<br/>").forEach((item) => arr.push(`${item.trim()}`));
      this.content = arr.join("\n");
      // this.matchText()
      setTimeout(() => {
        const w = Number(
          window.getComputedStyle(this.$refs.textarea).width.replace("px", "")
        );
        if (w < this.fontSize + 1) {
          this.width = this.fontSize + 1;
        }
        this.height = window
          .getComputedStyle(this.$refs.textarea)
          .height.replace("px", "");
        
      }, 20);
      }
      
    },
    fontSize(val) {
      this.matchText();
      if (this.width < val) {
        this.width = val;
      }
      this.fSize = val;
    },
    active(val) {
      if (val) {
        this.enabled = true;
        this.$emit("activated", this.dragIndex);
      } else {
        this.cancelActive();
        this.$emit("deactivated");
      }
    },
    z(val) {
      if (val >= 0 || val === "auto") {
        this.zIndex = val;
        // this.$emit("changeDrag", this.dragIndex);
      }
    },
    x(val) {
      if (val != this.left) {
        this.$emit("changeDrag", this.dragIndex);
      }

      if (this.resizing || this.dragging) {
        return;
      }

      if (this.parent) {
        this.bounds = this.calcDragLimits();
      }
      this.moveHorizontally(val);
    },
    y(val) {
      if (val != this.top) {
        this.$emit("changeDrag", this.dragIndex);
      }

      if (this.resizing || this.dragging) {
        return;
      }

      if (this.parent) {
        this.bounds = this.calcDragLimits();
      }

      this.moveVertically(val);
      this.changeState = true;
    },
    lockAspectRatio(val) {
      if (val) {
        this.aspectFactor = this.width / this.height;
      } else {
        this.aspectFactor = undefined;
      }
      this.$emit("changeDrag", this.dragIndex);
    },
    minWidth(val) {
      if (val > 0 && val <= this.width) {
        this.minW = val;
      }
    },
    minHeight(val) {
      if (val > 0 && val <= this.height) {
        this.minH = val;
      }
    },
    maxWidth(val) {
      this.maxW = val;
    },
    maxHeight(val) {
      this.maxH = val;
    },
    w(val) {
      this.width = val;
      this.right = this.parentWidth - this.width - this.left;
    },
    h(val) {
      this.bottom = this.parentHeight - this.height - this.top;
      if (this.type == 8) {
        this.height = 1;
      } else {
        this.height = val;
      }
    },
    width(val) {
      this.moveLeft = val / 2 - 12;
      this.resizeMovebox();
    },
    height(val) {
      this.moveTop = val / 2 - 12;
      this.resizeMovebox();
    },
    left() {
      // this.resizeMovebox();
    },
    top() {
      // this.resizeMovebox();
    },
    borderLeft(val) {
      this.bLeft = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    borderTop(val) {
      this.bTop = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    borderRight(val) {
      this.bRight = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    borderBottom(val) {
      this.bBottom = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    borderColor(val) {
      this.bordersColor = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    borderStyle(val) {
      this.bStyle = val;
      this.$emit("changeDrag", this.dragIndex);
    },
    showDrag(val) {
      if (!val) {
        removeEvent(document.documentElement, eventsFor.move, this.move);
      }
    }
  },
};
</script>
<style lang="scss">
.type3 {
  position: absolute;
  height: 30px;
  width: 60px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  bottom: -38px;
  cursor: pointer;
  left: 50%;
  background: #1e6ea3;
  text-align: center;
  transform: translateX(-50%);
  line-height: 30px;
}

.img2 {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.text {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  background: transparent;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 0;
  margin: 0;
}

.text::-webkit-scrollbar {
  display: none;
}

.borderStyle {
  font-size: 12px;
  color: #555;
  outline: none;
  border: none;
}

.vdr .back {
  width: 100%;
  opacity: 1;
  overflow: hidden;
  position: relative;
  img.moves {
    transition: all 0.4s ease-in-out;
  }
  .rotateImg {
    position: absolute;
  }

  // display: flex;
  // flex-direction: row;
  // align-items: center;
  // justify-content: center;
}
.vdr .back2 {
  width: 100%;
  opacity: 0.6;
  position: relative;
  img.moves {
    transition: all 0.4s ease-in-out;
  }
  .rotateImg {
    position: absolute;
  }

  // display: flex;
  // flex-direction: row;
  // align-items: center;
  // justify-content: center;
}
.vdr.active::before {
  left: -3px;
  right: -3px;
  top: -3px;
  bottom: -3px;
  position: absolute;
  content: "";
  border: 3px solid #8e7fe4;
  z-index: -1;
}
.vdr.active.nofill::before {
  left: -3px;
  right: -3px;
  top: -3px;
  bottom: -3px;
  position: absolute;
  content: "";
  border: 3px solid #d44339;
  z-index: -1;
}
.move {
  position: absolute;
  width: 24px;
  height: 24px;
}

.moveBOX {
  position: absolute;
  z-index: 1000;
  display: flex;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  flex-direction: column;

  i {
    font-size: 25px;
    color: #399fe4;
  }

  img {
    width: 23px;
    height: 23px;
    margin: 6px 0;
    cursor: move;
  }
}

.icon-xuanzhuan {
  font-size: 22px;
  position: absolute;
  left: 50%;
  top: -40px;
  transform: translateX(-50%);
  color: #00a0e9;
  font-weight: bold;
}

.handles {
  position: fixed;
  transform: translateX(-50%);
  width: 460px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  box-sizing: border-box;
  line-height: 26px;
  border-radius: 3px;
  z-index: 10000;
}

.handles .line {
  font-size: 12px;
  color: #555;
  display: flex;
  flex-direction: row;
  margin: 4px 0;
  box-sizing: border-box;
}

.handles .line .item {
  border-radius: 2px;
  border: 1px solid #ddd;
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  margin: 0 2px;
  height: 26px;
  line-height: 26px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.handles .line .iconfont {
  font-size: 13px;
}

.handles .line .item .name {
  margin-right: 3px;
}

.handles .line .item > i {
  margin-right: 4px;
}

.move {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 100%;
  cursor: pointer;
}

.updown {
  width: 15px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-left: 5px;
}

.updown i {
  font-size: 11px;
  border-radius: 1px;
  border: 1px solid #ddd;
  width: 19px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  box-sizing: border-box;
}

.handles ::v-deep .el-color-picker__trigger {
  display: inline-block;
  box-sizing: border-box;
  height: 28px;
  width: 28px;
  padding: 4px;
  border: none;
  border-radius: 4px;
  font-size: 0;
  position: relative;
  cursor: pointer;
}

p {
  margin-bottom: 4px !important;
}

.text ::v-deep p {
  margin-bottom: 4px;
}

.text ::v-deep p.ql-align-center {
  text-align: center !important;
}

.text .ql-align-justify {
  text-align: justify;
}

.stars {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  i {
    height: 30px;
    line-height: 30px;
  }

  .icon-star,
  .icon-star-full {
    margin: 0 0.16em;
  }
  
  .star-item {
    flex: 1 1 0%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

textarea {
  overflow: visible;
  border: none;

  &.text {
    background: rgba($color: #000000, $alpha: 0.02);
  }
}
.lock-drag {
  position: absolute;
  left: -4px;
  top: -44px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: #fff;
  color: #1280da;
  border: 1px solid #fff;
  text-align: center;
  line-height: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.5);
  justify-content: center;
  cursor: pointer;
  i {
    font-size: 22px;
    font-weight: bold;
  }
  img {
    width: 22px;
    height: 22px;
  }
}

.vdr .ant-spin-container {
  width: 100%;
  height: 100%;
}
div  .icon-star-full.hui {
    color: #cdcdcd!important;
  }
  .icon-star-full.hide{
    visibility: hidden;
  }
  .star-item .hui {
    color: #cdcdcd!important;
  }
  .star-item .hide {
    visibility: hidden;
  }

  .icon-star:before {
    content: "\e9a2";
}
</style>
